import { Component, OnInit } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ReleaseDetail } from '../models/release-detail.model';
import { CapabilityDetail } from '../models/capability-detail.model';
import { Allocation } from '../models/allocation.model';
import { OperatingUnit } from '../models/operating-unit.model';
import { MaterialEstimate } from '../models/material-estimate.model';
import { Building } from '../models/building.model';
import { LaborDetail } from '../models/labor-detail.model';
import { DataService } from '../services/data.service';
import _ from 'lodash';
import { GraphUser } from '../models/graph-user.model';
import { FormControl, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ContingencyDetail } from '../models/contingency-detail.model';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { CapabilityDescriptionComponent } from '../capability-description/capability-description.component';
import { UploadFile } from '../models/upload-file.model';
import { PatiProject } from '../models/pati-project.model';
import { ConfirmDeleteFormDialogComponent } from '../confirm-delete-form-dialog/confirm-delete-form-dialog.component';

@Component({
  selector: 'app-it-project-estimate',
  templateUrl: './it-project-estimate.component.html',
  styleUrls: ['./it-project-estimate.component.scss'],
  standalone: false,
})
export class ItProjectEstimateComponent implements OnInit {
  accountingModelDerivation: any[];
  additionalApproverControl: FormControl[];
  additionalApproverOptions: GraphUser[][];
  additionalApprovers: GraphUser[];
  additionalComments: string;
  agileEffort: string;
  allocationDefaultList: any[];
  allocationDefaults: any[];
  allocationDefaultsControl = new FormControl();
  allocationFunctions: any[] = [];
  allocations: Allocation[];
  allocationsTouched: boolean;
  approverList: any[];
  associatedRetirement: string;
  buForStateOptions: string[];
  buildingControl: FormControl[];
  buildingInfo: any;
  buildingInfoControl = new FormControl();
  buildingInfoOptions: any[];
  buildings: Building[];
  businessUnit: string;
  businessUnitDescription: string;
  chargeTypeControl: FormControl[];
  chargeTypeOptions: string[];
  clearUOPValues: boolean;
  combinedBusinessUnit: string;
  commonProjectClasses: string[];
  commonProjectTypes: any;
  commonUOPOptions: string[];
  contingencyCostControl: FormControl[];
  contingencyCostOptions: string[];
  contingencyDetails: ContingencyDetail[];
  contractualRight: string;
  costControl: FormControl[][];
  costOptions: string[];
  dataConversionActivities: string;
  defaultOption: any;
  defaultOptionChoices: any[];
  defaultsByDepartment: any[];
  department: any;
  departmentControl = new FormControl();
  departmentOptions: any[];
  descriptionOptions: any[];
  displayRevisionNumber: number;
  distributeCost: any;
  distributeCostControl = new FormControl();
  distributeOptions: any[];
  doaAmounts: number[];
  draftSaved: string;
  draftSavedDate: Date;
  draftSavedDay: string;
  draftSavedTime: string;
  estimatedInServiceDate: Date;
  estimatedStartDate: Date;
  etsPacAssignment: any;
  expandedBuildingInfoOptions: any[];
  expectedLife: number;
  extraBuildings: string[];
  files: UploadFile[];
  filteredAllocationDefaults: Observable<any[]>;
  filteredBuildingInfoOptions: Observable<any[]>;
  filteredBuildingOptions: Observable<any[]>[];
  filteredChargeTypeOptions: Observable<string[]>[];
  filteredContingencyCostOptions: Observable<string[]>[];
  filteredCostOptions: Observable<any[]>[][];
  filteredDepartmentOptions: Observable<any[]>;
  filteredDistributeOptions: Observable<any[]>;
  filteredFundingProjectOptions: Observable<any[]>[];
  filteredOperatingUnitOptions: Observable<OperatingUnit[]>[];
  filteredStateOptions: Observable<any[]>[];
  filteredUnitOfPropertyDescriptionOptions: Observable<any[]>[][];
  filteredWorkDescriptionOptions: Observable<any[]>[];
  filteredWorkTaskOptions: Observable<string[]>[];
  firstBuildingTouched: boolean;
  firstName: string;
  formNumber: string;
  formOwner: GraphUser;
  fundingProjectControl: FormControl[];
  hardwareOrSoftware: string;
  howSoftwareReleased: string;
  inServiceYear: string;
  isFeasible: string;
  isLighthouseProject: string;
  isRevisionIndicator: boolean;
  itProjectClassification: any;
  itSparGuid: string;
  itSponsor: GraphUser;
  laborDetails: LaborDetail[];
  lastFilter: string = '';
  lastName: string;
  maintenanceContracts: string;
  nuclearAbbreviations: any[];
  omOnly: string;
  operatingUnit: OperatingUnit;
  operatingUnitControl: FormControl[];
  operatingUnitOptions: OperatingUnit[];
  parser: DOMParser;
  patiProject: PatiProject;
  perpetualLicenses: string;
  previousCapitalSubtotal: number;
  previousOMSubtotal: number;
  primaryContact: GraphUser;
  projectConsistsOf: string[];
  projectName: string;
  projectScopeDescription: string;
  purchasingWarranties: string;
  relatedWork: string;
  releaseDetails: ReleaseDetail[];
  replacingInterfaces: string;
  retiredInServiceDate: string;
  serviceFees: string;
  showErrorsDisclaimer: boolean;
  showMaterialHardwareOnlyErrorDisclaimer: boolean;
  showMaterialHardwareSoftwareErrorDisclaimer: boolean;
  showMaterialOmOnlyErrorDisclaimer: boolean;
  showMaterialSoftwareOnlyErrorDisclaimer: boolean;
  significantPenalty: string;
  softwareBeingUsed: string;
  softwareName: string;
  softwareProjectOverview: string;
  softwareToBeRetired: string;
  stateControl: FormControl[];
  todayDate: string;
  trainingCosts: string;
  unitOfPropertyDescriptionControl: FormControl[][];
  uopDescriptionOptions: any[];
  uopOptions: string[];
  userEmail: string;
  userName: string;
  userRoles: string[] = [];
  useWithoutPaying: string;
  vendorName: string;
  workDescriptionControl: FormControl[];
  workDescriptions: any[][];
  workTaskControl: FormControl[];
  workTaskOptions: any[];
  xmlDoc: any;
  private httpNoInterceptors: HttpClient;

  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private dataService: DataService,
    private router: Router,
    private httpBackend: HttpBackend
  ) {
    this.httpNoInterceptors = new HttpClient(httpBackend);
    this.departmentOptions = [];
    this.buildingInfoOptions = [];
    this.extraBuildings = [];
    this.distributeOptions = [];
    this.costOptions = [];
    this.workTaskOptions = [];
    this.contingencyCostOptions = [];
    this.chargeTypeOptions = [];
    this.operatingUnitOptions = [];
    this.filteredOperatingUnitOptions = [new Observable<OperatingUnit[]>()];
    this.filteredFundingProjectOptions = [new Observable<any[]>()];
    this.filteredStateOptions = [new Observable<any[]>()];
    this.buForStateOptions = [];
    this.commonProjectClasses = [];
    this.commonProjectTypes = [];
    this.allocationDefaults = [];
    this.allocationDefaultList = [];
    this.commonUOPOptions = [];
    this.uopOptions = [];
    this.parser = new DOMParser();
    this.loadProjectData();
  }

  ngOnInit() {
    let userData = JSON.parse(sessionStorage.getItem('userInfo'));
    if (userData) {
      this.userRoles = (userData.idTokenClaims && userData.idTokenClaims.roles) || [];
      let stringArray = userData.account.name.split(',');
      this.lastName = stringArray[0];
      this.firstName = stringArray[1].substring(1);
      this.userName = this.firstName + ' ' + this.lastName;
      this.userEmail = userData.account.username;
    }
    this.loadDepartmentFile();
    this.loadBuildingFile();
    this.loadDistributionOptionsFile();
    this.loadCostOptionsFile();
    this.loadWorkTaskOptionsFile();
    this.loadContingencyCostOptionsFile();
    this.loadChargeTypeOptionsFile();
    this.loadOperatingUnitFile();
    this.loadBUForStateFile();
    this.loadCommonProjectClassFile();
    this.loadCommonProjectTypeFile();
    this.loadAllocationDefaults();
    this.loadCommonUOPProjectsFile();
    this.loadUOPOptionsFile();
    this.loadDefaultsByDepartmentFile();
    this.loadNuclearAbbreviations();
    this.loadAccountingModelDerivation();
    this.loadAllocationFunctions();
  }

  loadAllocationFunctions() {
    this.http.get('assets/allocation-functions.json').subscribe(
      (result) => {
        let options = result as string[];
        options.sort();
        this.allocationFunctions = options;
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Department Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Department Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadDepartmentFile() {
    this.http.get('assets/department-options.json').subscribe(
      (result) => {
        let options = result as string[];
        options.sort();
        this.departmentOptions = options;
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Department Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Department Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadBuildingFile() {
    this.http.get('assets/building-options.json').subscribe(
      (result) => {
        this.buildingInfoOptions = result as string[];
        this.loadExtraBuildingOptions();
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Building Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Building Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadDistributionOptionsFile() {
    this.http.get('assets/distributing-options.json').subscribe(
      (result) => {
        this.distributeOptions = result as string[];
        this.filteredDistributeOptions = this.distributeCostControl.valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) => this.distributeCostFilter(filter))
        );
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Distributing Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Distributing Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadWorkTaskOptionsFile() {
    this.http.get('assets/work-task-options.json').subscribe(
      (result) => {
        this.workTaskOptions = result as any[];
        if (this.hardwareOrSoftware === 'Hardware Only') {
          this.workTaskOptions.splice(2, 2);
          // this.workTaskOptions = ['Hardware-CAP', 'Hardware-O&M', 'Hardware-Removal'];
        }
        if (this.hardwareOrSoftware === 'Software Only') {
          this.workTaskOptions.splice(4, 1);
          this.workTaskOptions.splice(0, 2);
          //this.workTaskOptions = ['Software-CAP', 'Software-O&M'];
        }
        if (this.hardwareOrSoftware === 'O&M Only') {
          this.workTaskOptions = [
            {
              workTask: 'Labor-O&M',
              workDescriptions: ['Labor-O&M'],
            },
          ];
          //this.workTaskOptions = ['Labor-O&M'];
        }
        for (let i = 0; i < this.laborDetails.length; i++) {
          this.filteredWorkTaskOptions[i] = this.workTaskControl[i].valueChanges.pipe(
            startWith<string | any[]>(''),
            map((value) => (typeof value === 'string' ? value : this.lastFilter)),
            map((filter) => this.workTaskFilter(filter))
          );
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Work Task Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Work Task Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadContingencyCostOptionsFile() {
    this.http.get('assets/contingency-cost-options.json').subscribe(
      (result) => {
        this.contingencyCostOptions = result as string[];
        if (this.hardwareOrSoftware === 'O&M Only') {
          this.contingencyCostOptions = ['Contingency-O&M', 'Other-O&M'];
        } else if (this.hardwareOrSoftware === 'Software Only') {
          this.contingencyCostOptions = [
            'Contingency-CAP',
            'Contingency-O&M',
            'Other-CAP',
            'Other-O&M',
          ];
        }
        for (let i = 0; i < this.contingencyDetails.length; i++) {
          this.filteredContingencyCostOptions[i] = this.contingencyCostControl[i].valueChanges.pipe(
            startWith<string | any[]>(''),
            map((value) => (typeof value === 'string' ? value : this.lastFilter)),
            map((filter) => this.contingencyCostFilter(filter))
          );
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Work Task Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Work Task Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadChargeTypeOptionsFile() {
    this.http.get('assets/charge-type-options.json').subscribe(
      (result) => {
        this.chargeTypeOptions = result as string[];
        for (let i = 0; i < this.laborDetails.length; i++) {
          this.filteredChargeTypeOptions[i] = this.chargeTypeControl[i].valueChanges.pipe(
            startWith<string | any[]>(''),
            map((value) => (typeof value === 'string' ? value : this.lastFilter)),
            map((filter) => this.chargeTypeFilter(filter))
          );
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Charge Type Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Charge Type Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  generateTodaysDate() {
    let today = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    this.todayDate =
      today.getFullYear().toString() +
      '-' +
      (today.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      today.getDate().toString().padStart(2, '0');
  }

  addCapability(index: number) {
    this.releaseDetails[index].capabilityDetails.push(new CapabilityDetail());
    if (this.releaseDetails[index].capabilityDetails.length > 1) {
      this.releaseDetails[index].capabilityDetails[
        this.releaseDetails[index].capabilityDetails.length - 1
      ].releaseNumber = this.releaseDetails[index].capabilityDetails[0].releaseNumber;
      this.releaseDetails[index].capabilityDetails[
        this.releaseDetails[index].capabilityDetails.length - 1
      ].releaseDate = this.releaseDetails[index].capabilityDetails[0].releaseDate;
    }
  }

  releaseNumberChange(index: number, jindex: number) {
    if (jindex === 0) {
      if (this.releaseDetails[index].capabilityDetails.length > 0) {
        for (let i = 1; i < this.releaseDetails[index].capabilityDetails.length; i++) {
          this.releaseDetails[index].capabilityDetails[i].releaseNumber =
            this.releaseDetails[index].capabilityDetails[0].releaseNumber;
        }
      }
    }
  }

  releaseDateChange(index: number, jindex: number) {
    if (jindex === 0) {
      if (this.releaseDetails[index].capabilityDetails.length > 0) {
        for (let i = 1; i < this.releaseDetails[index].capabilityDetails.length; i++) {
          this.releaseDetails[index].capabilityDetails[i].releaseDate =
            this.releaseDetails[index].capabilityDetails[0].releaseDate;
        }
      }
    }
  }

  addRelease() {
    this.releaseDetails.push(new ReleaseDetail());
  }

  isOdd(index: number) {
    return index % 2;
  }

  deleteRelease(i: number, j: number) {
    this.releaseDetails[i].capabilityDetails.splice(j, 1);
    if (this.releaseDetails[i].capabilityDetails.length === 0) {
      this.releaseDetails.splice(i, 1);
    }
  }

  deleteEstimate(i: number, j: number) {
    this.buildings[i].materialEstimates.splice(j, 1);
    this.filteredCostOptions[i].splice(j, 1);
    this.costControl[i].splice(j, 1);
    this.filteredUnitOfPropertyDescriptionOptions[i].splice(j, 1);
    this.unitOfPropertyDescriptionControl[i].splice(j, 1);
  }

  deleteAllocation(i: number) {
    this.allocations.splice(i, 1);
    this.operatingUnitControl.splice(i, 1);
    this.filteredOperatingUnitOptions.splice(i, 1);
    this.filteredFundingProjectOptions.splice(i, 1);
    this.filteredStateOptions.splice(i, 1);
    this.fundingProjectControl.splice(i, 1);
    this.stateControl.splice(i, 1);
    this.getUOPDescriptionChoices();
  }

  deleteBuilding(i: number) {
    this.buildings.splice(i, 1);
    this.buildingControl.splice(i, 1);
    this.filteredBuildingOptions.splice(i, 1);
    this.filteredCostOptions.splice(i, 1);
    this.costControl.splice(i, 1);
    this.filteredUnitOfPropertyDescriptionOptions.splice(i, 1);
    this.unitOfPropertyDescriptionControl.splice(i, 1);
  }

  deleteLaborDetail(i: number) {
    this.laborDetails.splice(i, 1);
    this.workDescriptions.splice(i, 1);
    this.filteredWorkTaskOptions.splice(i, 1);
    this.workTaskControl.splice(i, 1);
    this.filteredWorkDescriptionOptions.splice(i, 1);
    this.workDescriptionControl.splice(i, 1);
    this.filteredChargeTypeOptions.splice(i, 1);
    this.chargeTypeControl.splice(i, 1);
  }

  deleteContingencyDetail(i: number) {
    this.contingencyDetails.splice(i, 1);
    this.filteredContingencyCostOptions.splice(i, 1);
    this.contingencyCostControl.splice(i, 1);
  }

  addNewAllocation() {
    this.allocations.push(new Allocation());
    this.operatingUnitControl.push(new FormControl());
    this.fundingProjectControl.push(new FormControl());
    this.stateControl.push(new FormControl());
    this.filteredOperatingUnitOptions.push(new Observable<OperatingUnit[]>());
    this.filteredOperatingUnitOptions[this.filteredOperatingUnitOptions.length - 1] =
      this.operatingUnitControl[this.operatingUnitControl.length - 1].valueChanges.pipe(
        startWith<string | any[]>(''),
        map((value) => (typeof value === 'string' ? value : this.lastFilter)),
        map((filter) => this.operatingUnitFilter(filter))
      );
    this.filteredFundingProjectOptions.push(new Observable<any[]>());
    this.filteredFundingProjectOptions[this.filteredFundingProjectOptions.length - 1] =
      this.fundingProjectControl[this.fundingProjectControl.length - 1].valueChanges.pipe(
        startWith<string | any[]>(''),
        map((value) => (typeof value === 'string' ? value : this.lastFilter)),
        map((filter) =>
          this.fundingProjectFilter(filter, this.allocations[this.allocations.length - 1])
        )
      );
    this.filteredStateOptions.push(new Observable<any[]>());
    this.filteredStateOptions[this.filteredStateOptions.length - 1] = this.stateControl[
      this.stateControl.length - 1
    ].valueChanges.pipe(
      startWith<string | any[]>(''),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.stateFilter(filter, this.allocations[this.allocations.length - 1]))
    );
  }

  addMaterial(index: number) {
    this.buildings[index].materialEstimates.push(new MaterialEstimate());
    if (this.hardwareOrSoftware === 'O&M Only') {
      this.buildings[index].materialEstimates[
        this.buildings[index].materialEstimates.length - 1
      ].cost = 'O&M';
    }
    if (!this.filteredCostOptions[index]) {
      this.filteredCostOptions[index] = [];
    }
    this.filteredCostOptions[index].push(new Observable<any[]>());
    if (!this.costControl[index]) {
      this.costControl[index] = [];
    }
    this.costControl[index].push(new FormControl());
    this.filteredCostOptions[index][this.filteredCostOptions[index].length - 1] = this.costControl[
      index
    ][this.costControl[index].length - 1].valueChanges.pipe(
      startWith<string | any[]>(''),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.costFilter(filter))
    );
    if (!this.filteredUnitOfPropertyDescriptionOptions[index]) {
      this.filteredUnitOfPropertyDescriptionOptions[index] = [];
    }
    this.filteredUnitOfPropertyDescriptionOptions[index].push(new Observable<any[]>());
    if (!this.unitOfPropertyDescriptionControl[index]) {
      this.unitOfPropertyDescriptionControl[index] = [];
    }
    this.unitOfPropertyDescriptionControl[index].push(new FormControl());
    this.filteredUnitOfPropertyDescriptionOptions[index][
      this.filteredUnitOfPropertyDescriptionOptions[index].length - 1
    ] = this.unitOfPropertyDescriptionControl[index][
      this.unitOfPropertyDescriptionControl[index].length - 1
    ].valueChanges.pipe(
      startWith<string | any[]>(''),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.unitOfPropertyDescriptionFilter(filter))
    );
  }

  addBuilding() {
    this.buildings.push(new Building());
    this.buildingControl.push(new FormControl());
    this.filteredBuildingOptions.push(new Observable<any[]>());
    this.filteredBuildingOptions[this.buildings.length - 1] = this.buildingControl[
      this.buildings.length - 1
    ].valueChanges.pipe(
      startWith<string | any[]>(''),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.buildingInfoFilter(filter))
    );
  }

  addLaborDetail() {
    this.laborDetails.push(new LaborDetail());
    this.filteredWorkTaskOptions.push(new Observable<string[]>());
    this.workTaskControl.push(new FormControl());
    this.filteredWorkTaskOptions[this.filteredWorkTaskOptions.length - 1] = this.workTaskControl[
      this.workTaskControl.length - 1
    ].valueChanges.pipe(
      startWith<string | any[]>(''),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.workTaskFilter(filter))
    );
    this.filteredWorkDescriptionOptions.push(new Observable<any[]>());
    this.workDescriptionControl.push(new FormControl());
    this.workDescriptions.push([]);
    this.filteredChargeTypeOptions.push(new Observable<string[]>());
    this.chargeTypeControl.push(new FormControl());
    this.filteredChargeTypeOptions[this.filteredChargeTypeOptions.length - 1] =
      this.chargeTypeControl[this.chargeTypeControl.length - 1].valueChanges.pipe(
        startWith<string | any[]>(''),
        map((value) => (typeof value === 'string' ? value : this.lastFilter)),
        map((filter) => this.chargeTypeFilter(filter))
      );
    if (this.hardwareOrSoftware === 'O&M Only') {
      this.laborDetails[this.laborDetails.length - 1].workTask = {
        workTask: {
          workTask: 'Labor-O&M',
          workDescriptions: ['Labor-O&M'],
        },
        workDescriptions: ['Labor-O&M'],
      };
      this.workTaskChanged(
        {
          workTask: {
            workTask: 'Labor-O&M',
            workDescriptions: ['Labor-O&M'],
          },
          workDescriptions: ['Labor-O&M'],
        },
        this.laborDetails.length - 1
      );
    }
  }

  addContingencyDetail() {
    this.contingencyDetails.push(new ContingencyDetail());
    this.filteredContingencyCostOptions.push(new Observable<string[]>());
    this.contingencyCostControl.push(new FormControl());
    this.filteredContingencyCostOptions[this.filteredContingencyCostOptions.length - 1] =
      this.contingencyCostControl[this.contingencyCostControl.length - 1].valueChanges.pipe(
        startWith<string | any[]>(''),
        map((value) => (typeof value === 'string' ? value : this.lastFilter)),
        map((filter) => this.contingencyCostFilter(filter))
      );
  }

  allocationTotal() {
    let total = 0;
    for (let i = 0; i < this.allocations.length; i++) {
      total += this.allocations[i].percentage;
    }
    return Number(total.toPrecision(6));
  }

  loadCostOptionsFile() {
    this.http.get('assets/cost-options.json').subscribe(
      (result) => {
        this.costOptions = result as string[];
        if (this.hardwareOrSoftware === 'O&M Only') {
          this.costOptions = ['O&M'];
        }
        for (let i = 0; i < this.buildings.length; i++) {
          for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
            if (this.clearUOPValues) {
              this.buildings[i].materialEstimates[j].cost = null;
            }
            this.filteredCostOptions[i][j] = this.costControl[i][j].valueChanges.pipe(
              startWith<string | any[]>(''),
              map((value) => (typeof value === 'string' ? value : this.lastFilter)),
              map((filter) => this.costFilter(filter))
            );
          }
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Distributing Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Distributing Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadOperatingUnitFile() {
    this.http.get('assets/operating-units.json').subscribe(
      (result) => {
        this.operatingUnitOptions = result as OperatingUnit[];
        this.filteredOperatingUnitOptions[0] = this.operatingUnitControl[0].valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) => this.operatingUnitFilter(filter))
        );
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat('Load OU File Error - ', error.error.message);
        } else {
          errorDescription = errorDescription.concat('Load OU File Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadBUForStateFile() {
    this.http.get('assets/bu-for-state.json').subscribe(
      (result) => {
        this.buForStateOptions = result as string[];
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load BU For State Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load BU For State Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadCommonProjectClassFile() {
    this.http.get('assets/common-project-class.json').subscribe(
      (result) => {
        this.commonProjectClasses = result as string[];
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Common Project Class Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Common Project Class Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadCommonProjectTypeFile() {
    this.http.get('assets/common-project-type.json').subscribe(
      (result) => {
        this.commonProjectTypes = result as any;
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Common Project Type Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Common Project Type Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadCommonUOPProjectsFile() {
    this.http.get('assets/common-uop-options.json').subscribe(
      (result) => {
        this.commonUOPOptions = result as any;
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Common UOP Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Common UOP Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadUOPOptionsFile() {
    this.http.get('assets/uop-options.json').subscribe(
      (result) => {
        let setOfUopOptions = result as string[];
        if (this.hardwareOrSoftware === 'Hardware Only') {
          this.uopOptions = setOfUopOptions.slice(0, -2);
        } else if (this.hardwareOrSoftware === 'Software Only') {
          this.uopOptions = setOfUopOptions.slice(6);
        } else {
          this.uopOptions = setOfUopOptions;
        }
        for (let i = 0; i < this.buildings.length; i++) {
          for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
            if (this.buildings[i].materialEstimates[j].unitOfPropertyDescription) {
              const validValue = this.uopOptions.find(
                (v) => v === this.buildings[i].materialEstimates[j].unitOfPropertyDescription
              );
              if (!validValue || this.clearUOPValues) {
                this.buildings[i].materialEstimates[j].unitOfPropertyDescription = null;
              }
            }
            this.filteredUnitOfPropertyDescriptionOptions[i][j] =
              this.unitOfPropertyDescriptionControl[i][j].valueChanges.pipe(
                startWith<string | any[]>(''),
                map((value) => (typeof value === 'string' ? value : this.lastFilter)),
                map((filter) => this.unitOfPropertyDescriptionFilter(filter))
              );
          }
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load UOP Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load UOP Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadAllocationDefaults() {
    this.http.get('assets/allocation-defaults.json').subscribe(
      (result) => {
        this.allocationDefaultList = result as any;
        /*if (this.defaultOption) {
        let matchFound = false;
        for (let i = 0; i < this.allocationDefaults.length && !matchFound; i++) {
          if (this.allocationDefaults[i].default === this.defaultOption.default) {
            this.defaultOption = this.allocationDefaults[i];
            matchFound = true;
          }
        }
      }*/
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Allocation Defaults Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Allocation Defaults Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadDefaultsByDepartmentFile() {
    this.http.get('assets/defaults-by-department.json').subscribe(
      (result) => {
        this.defaultsByDepartment = result as any;
        this.filteredDepartmentOptions = this.departmentControl.valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) => this.departmentFilter(filter))
        );
        /*if (this.defaultOption) {
        let matchFound = false;
        for (let i = 0; i < this.allocationDefaults.length && !matchFound; i++) {
          if (this.allocationDefaults[i].default === this.defaultOption.default) {
            this.defaultOption = this.allocationDefaults[i];
            matchFound = true;
          }
        }
      }*/
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Defaults By Department Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Defaults By Department Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadAccountingModelDerivation() {
    this.http.get('assets/accounting-model-derivation.json').subscribe(
      (result) => {
        this.accountingModelDerivation = result as any[];
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Accounting Model Derivation Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Accounting Model Derivation Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  setBusinessUnit(allocation: Allocation, value: any, index: number) {
    allocation.businessUnitValue = value.BUSINESS_UNIT;
    allocation.businessUnit = value.BUSINESS_UNIT.concat(' - ').concat(value.BU_DESCR);
    this.setAllocationSetId(allocation, value.BUSINESS_UNIT);

    let matchFound = false;
    for (let i = 0; i < this.buForStateOptions.length && !matchFound; i++) {
      if (value.BUSINESS_UNIT === this.buForStateOptions[i]) {
        matchFound = true;
        allocation.stateOptions = ['NC', 'SC', 'NC & SC'];
      }
    }
    if (!matchFound) {
      allocation.stateOptions = [];
    }
    this.filteredStateOptions[index] = this.stateControl[index].valueChanges.pipe(
      startWith<string | any[]>(''),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.stateFilter(filter, allocation))
    );
  }

  setAllocationSetId(allocation: Allocation, businessUnit) {
    let callBody = {
      businessUnit: [businessUnit],
    };
    this.dataService.getFireHubData('fihub_get_acct_model', callBody).subscribe(
      (result: any) => {
        if (result.length > 0) {
          allocation.setId = result[0].ACCT_MODEL_SETID;
        } else {
          allocation.setId = '';
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get FiHub SetID Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get FiHub SetID Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getAllocationFunctions(allocation: Allocation) {
    const val = this.allocationFunctions.find((a) => a.setId === allocation.setId);
    return val ? val.functions : [];
  }

  showFunctionField(allocation: Allocation) {
    return ['PWGCT', 'EDIST'].includes(allocation.setId);
  }

  isAllocationFunctionVisible(allocations: Allocation[]) {
    return allocations.some((a) => this.showFunctionField(a));
  }

  getFundingProjectIDChoices(
    allocation: Allocation,
    value: any,
    index: number,
    isDefault?: boolean,
    reload?: boolean
  ) {
    allocation.fundingProjectOptions = [];
    if (!reload) {
      allocation.fundingProjectID = '';
    }
    let callBody;
    if (isDefault) {
      callBody = {
        businessUnit: value,
      };
    } else {
      callBody = {
        businessUnit: value.BUSINESS_UNIT,
      };
    }
    this.dataService.getAthenaData('itspar_bu_funding_prjs', callBody).subscribe(
      (result: any) => {
        allocation.fundingProjectOptions = JSON.parse(result);
        if (allocation.fundingProjectOptions.length === 0) {
          allocation.hasFundingError = true;
        } else {
          allocation.hasFundingError = false;
        }
        this.sortFundingProjectOptions(allocation);
        this.filteredFundingProjectOptions[index] = this.fundingProjectControl[
          index
        ].valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) => this.fundingProjectFilter(filter, allocation))
        );
        if (reload) {
          let matchFound = false;
          for (let i = 0; i < allocation.fundingProjectOptions.length && !matchFound; i++) {
            if (
              allocation.fundingProjectID.work_order_number ===
              allocation.fundingProjectOptions[i].work_order_number
            ) {
              matchFound = true;
              allocation.fundingProjectID = allocation.fundingProjectOptions[i];
            }
          }
        }
        if (
          !reload &&
          allocation.businessUnitValue !== '20048' &&
          allocation.businessUnitValue !== '50125'
        ) {
          let matchFound = false;
          for (let i = 0; i < allocation.fundingProjectOptions.length && !matchFound; i++) {
            const defaultFPIT =
              allocation.fundingProjectOptions[i].work_order_number.startsWith('FPIT');

            const defaultPIEDMONT =
              allocation.businessUnitValue === '47156' &&
              allocation.fundingProjectOptions[i].work_order_number.startsWith('PIEDMONT');

            if (defaultFPIT || defaultPIEDMONT) {
              matchFound = true;
              allocation.fundingProjectID = allocation.fundingProjectOptions[i];
            }
          }
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Funding Project ID Choices Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Funding Project ID Choices Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getProjectClassChoices(allocation: Allocation, value: any, isDefault?: boolean) {
    allocation.projectClassOptions = [];
    let callBody;
    if (isDefault) {
      callBody = {
        businessUnit: value,
      };
    } else {
      callBody = {
        businessUnit: value.BUSINESS_UNIT,
      };
    }
    this.dataService.getAthenaData('rre_wogtype_prjclass', callBody).subscribe(
      (result: any) => {
        allocation.projectClassOptions = JSON.parse(result);
        this.sortProjectClassOptions(allocation);
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Project Class Choices Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Project Class Choices Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getProjectTypeChoices(allocation: Allocation, value: any, isDefault?: boolean) {
    allocation.projectTypeOptions = [];
    let callBody;
    if (isDefault) {
      callBody = {
        businessUnit: value,
      };
    } else {
      callBody = {
        businessUnit: value.BUSINESS_UNIT,
      };
    }
    this.dataService.getAthenaData('it_spar_project_type', callBody).subscribe(
      (result: any) => {
        allocation.projectTypeOptions = JSON.parse(result);
        this.sortProjectTypeOptions(allocation, callBody.businessUnit);
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Project Type Choices Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Project Type Choices Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getUOPDescriptionChoices() {
    this.uopDescriptionOptions = [];
    let businessUnits = [];
    for (let i = 0; i < this.allocations.length; i++) {
      if (
        !businessUnits.includes(this.allocations[i].businessUnitValue) &&
        this.allocations[i].businessUnitValue
      ) {
        businessUnits.push(this.allocations[i].businessUnitValue);
      }
    }
    if (businessUnits.length > 0 && !businessUnits.includes(null)) {
      let callBody = {
        businessUnits: businessUnits,
      };
      this.dataService.getAthenaData('it_spar_uop_desc', callBody).subscribe(
        (result: any) => {
          this.uopDescriptionOptions = JSON.parse(result);
          this.sortUOPDescriptionOptions();
        },
        (error) => {
          console.log('error', error);
          let errorType = '';
          let errorDescription = '';
          if (error.error.message) {
            errorDescription = errorDescription.concat(
              'Get UOP Description Choices Error - ',
              error.error.message
            );
          } else {
            errorDescription = errorDescription.concat('Get UOP Description Choices Error');
          }
          errorType = errorType.concat(error.status, ' ', error.statusText);
          let dataStructure = {
            errorType: errorType,
            errorDescription: errorDescription,
          };
          this.dialog.open(ErrorDialogComponent, {
            data: dataStructure,
            disableClose: true,
          });
        }
      );
    }
  }

  sortFundingProjectOptions(allocation: Allocation) {
    allocation.fundingProjectOptions = _.sortBy(allocation.fundingProjectOptions, [
      'work_order_number',
    ]);
    allocation.fundingProjectOptions = _.sortBy(
      allocation.fundingProjectOptions,
      ['preferred'],
      ['desc']
    );
    let foundIndex = -1;
    for (let i = 0; i < allocation.fundingProjectOptions.length && foundIndex === -1; i++) {
      if (allocation.fundingProjectOptions[i].preferred === 'Y') {
        foundIndex = i;
      }
    }
    if (foundIndex != -1) {
      let preferredProjects = allocation.fundingProjectOptions.splice(
        foundIndex,
        allocation.fundingProjectOptions.length - foundIndex
      );
      allocation.fundingProjectOptions = preferredProjects.concat(allocation.fundingProjectOptions);
    }
  }

  sortProjectClassOptions(allocation: Allocation) {
    allocation.projectClassOptions = _.sortBy(allocation.projectClassOptions, ['description']);
    let commonClasses = [];
    for (let i = 0; i < allocation.projectClassOptions.length; i++) {
      if (
        this.commonProjectClasses.includes(allocation.projectClassOptions[i].description.trim())
      ) {
        commonClasses.push(allocation.projectClassOptions.splice(i, 1)[0]);
        i = i - 1;
      }
    }
    allocation.projectClassOptions = commonClasses.concat(allocation.projectClassOptions);
  }

  sortProjectTypeOptions(allocation: Allocation, businessUnit: string) {
    allocation.projectTypeOptions = _.sortBy(allocation.projectTypeOptions, ['description']);
    let commonTypes = [];
    for (let i = 0; i < this.commonProjectTypes.length; i++) {
      if (this.commonProjectTypes[i].businessUnit === businessUnit) {
        for (let j = 0; j < allocation.projectTypeOptions.length; j++) {
          if (
            this.commonProjectTypes[i].preferredValues.includes(
              allocation.projectTypeOptions[j].description.trim()
            )
          ) {
            commonTypes.push(allocation.projectTypeOptions.splice(j, 1)[0]);
            j = j - 1;
          }
        }
        allocation.projectTypeOptions = commonTypes.concat(allocation.projectTypeOptions);
      }
    }
  }

  sortUOPDescriptionOptions() {
    this.uopDescriptionOptions = _.sortBy(this.uopDescriptionOptions, ['uop_description']);
    let commonUOPOptions = [];
    for (let i = 0; i < this.uopDescriptionOptions.length; i++) {
      if (this.commonUOPOptions.includes(this.uopDescriptionOptions[i].uop_description.trim())) {
        commonUOPOptions.push(this.uopDescriptionOptions.splice(i, 1)[0]);
        i = i - 1;
      }
    }
    this.uopDescriptionOptions = commonUOPOptions.concat(this.uopDescriptionOptions);
  }

  internalOM() {
    let internalOM = 0;
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (
        this.laborDetails[i].workTask &&
        (this.laborDetails[i].workTask.workTask === 'Labor-O&M' ||
          this.laborDetails[i].workTask.workTask === 'Hardware-O&M' ||
          this.laborDetails[i].workTask.workTask === 'Software-O&M')
      ) {
        if (this.laborDetails[i].chargeType === 'Internal') {
          internalOM += Number(this.laborDetails[i].totalCosts || 0);
        }
      }
    }
    return Math.round(internalOM);
  }

  externalOM() {
    let externalOM = 0;
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (
        this.laborDetails[i].workTask &&
        (this.laborDetails[i].workTask.workTask === 'Labor-O&M' ||
          this.laborDetails[i].workTask.workTask === 'Hardware-O&M' ||
          this.laborDetails[i].workTask.workTask === 'Software-O&M')
      ) {
        if (this.laborDetails[i].chargeType === 'External') {
          externalOM += Number(this.laborDetails[i].totalCosts || 0);
        }
      }
    }
    return Math.round(externalOM);
  }

  materialOM() {
    let materialOM = 0;
    for (let i = 0; i < this.buildings.length; i++) {
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        if (this.buildings[i].materialEstimates[j].cost === 'O&M') {
          materialOM += Number(this.buildings[i].materialEstimates[j].totalCosts);
        }
      }
    }
    return Math.round(materialOM);
  }

  contingencyOM() {
    let contingencyOM = 0;
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      if (this.contingencyDetails[i].cost === 'Contingency-O&M') {
        contingencyOM += Number(this.contingencyDetails[i].totalCosts || 0);
      }
    }
    return Math.round(contingencyOM);
  }

  otherOM() {
    let otherOM = 0;
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      if (this.contingencyDetails[i].cost === 'Other-O&M') {
        otherOM += Number(this.contingencyDetails[i].totalCosts || 0);
      }
    }
    return Math.round(otherOM);
  }

  subtotalOM() {
    return (
      this.internalOM() +
      this.externalOM() +
      this.materialOM() +
      this.contingencyOM() +
      this.otherOM()
    );
  }

  subtotalOMThisRequest() {
    return this.subtotalOM() - this.previousOMSubtotal;
  }

  internalCapital(isAFUDC?: boolean) {
    let internalCapital = 0;
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (
        this.laborDetails[i].workTask &&
        (this.laborDetails[i].workTask.workTask === 'Hardware-CAP' ||
          (this.laborDetails[i].workTask.workTask === 'Hardware-Removal' && !isAFUDC) ||
          this.laborDetails[i].workTask.workTask === 'Software-CAP')
      ) {
        if (this.laborDetails[i].chargeType === 'Internal') {
          internalCapital += Number(this.laborDetails[i].totalCosts || 0);
        }
      }
    }
    return Math.round(internalCapital);
  }

  externalCapital(isAFUDC?: boolean) {
    let externalCapital = 0;
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (
        this.laborDetails[i].workTask &&
        (this.laborDetails[i].workTask.workTask === 'Hardware-CAP' ||
          (this.laborDetails[i].workTask.workTask === 'Hardware-Removal' && !isAFUDC) ||
          this.laborDetails[i].workTask.workTask === 'Software-CAP')
      ) {
        if (this.laborDetails[i].chargeType === 'External') {
          externalCapital += Number(this.laborDetails[i].totalCosts || 0);
        }
      }
    }
    return Math.round(externalCapital);
  }

  materialCapital() {
    let materialCapital = 0;
    for (let i = 0; i < this.buildings.length; i++) {
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        if (this.buildings[i].materialEstimates[j].cost === 'CAP') {
          materialCapital += Number(this.buildings[i].materialEstimates[j].totalCosts);
        }
      }
    }
    return Math.round(materialCapital);
  }

  contingencyCapital(isAFUDC?: boolean) {
    let contingencyCapital = 0;
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      if (
        this.contingencyDetails[i].cost === 'Contingency-CAP' ||
        (this.contingencyDetails[i].cost === 'Contingency-Removal' && !isAFUDC)
      ) {
        contingencyCapital += Number(this.contingencyDetails[i].totalCosts || 0);
      }
    }
    return Math.round(contingencyCapital);
  }

  otherCapital(isAFUDC?: boolean) {
    let otherCapital = 0;
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      if (
        this.contingencyDetails[i].cost === 'Other-CAP' ||
        (this.contingencyDetails[i].cost === 'Other-Removal' && !isAFUDC)
      ) {
        otherCapital += Number(this.contingencyDetails[i].totalCosts || 0);
      }
    }
    return Math.round(otherCapital);
  }

  subtotalCapital(isAFUDC?: boolean): number {
    return (
      this.internalCapital(isAFUDC) +
      this.externalCapital(isAFUDC) +
      this.materialCapital() +
      this.contingencyCapital(isAFUDC) +
      this.otherCapital(isAFUDC)
    );
  }

  subtotalCapitalThisRequest() {
    return this.subtotalCapital() - this.previousCapitalSubtotal;
  }

  estimatedAFUDC() {
    let percentageTotal = 0;
    for (let i = 0; i < this.allocations.length; i++) {
      if (
        this.allocations[i].businessUnitValue &&
        !this.allocations[i].businessUnitValue.startsWith('502')
      ) {
        percentageTotal += this.allocations[i].percentage;
      }
    }
    percentageTotal = percentageTotal / 100;
    let diffInDays = Math.floor(
      (+this.estimatedInServiceDate - +this.estimatedStartDate) / (1000 * 60 * 60 * 24)
    );
    return Math.round(
      (diffInDays / 360) * 0.065 * ((this.subtotalCapital(true) * percentageTotal) / 2)
    );
  }

  totalCapitalCost() {
    return this.subtotalCapital() + this.estimatedAFUDC();
  }

  totalProjectCost() {
    return this.totalCapitalCost() + this.subtotalOM();
  }

  buildingTotal() {
    let buildingTotal = 0;
    for (let i = 0; i < this.buildings.length; i++) {
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        buildingTotal += Number(this.buildings[i].materialEstimates[j].totalCosts);
      }
    }
    return Math.round(buildingTotal);
  }

  laborTotal() {
    let laborTotal = 0;
    for (let i = 0; i < this.laborDetails.length; i++) {
      laborTotal += Number(this.laborDetails[i].totalCosts || 0);
    }
    return Math.round(laborTotal);
  }

  contingencyTotal() {
    let contingencyTotal = 0;
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      contingencyTotal += Number(this.contingencyDetails[i].totalCosts || 0);
    }
    return Math.round(contingencyTotal);
  }

  loadProjectData() {
    let startDateCheck = sessionStorage.getItem('estimatedStartDate');
    if (startDateCheck) {
      this.estimatedStartDate = new Date(startDateCheck);
      this.estimatedStartDate.setDate(this.estimatedStartDate.getDate() + 1);
    } else {
      this.estimatedStartDate = null;
    }
    let inServiceDateCheck = sessionStorage.getItem('estimatedInServiceDate');
    if (inServiceDateCheck) {
      this.estimatedInServiceDate = new Date(inServiceDateCheck);
      this.estimatedInServiceDate.setDate(this.estimatedInServiceDate.getDate() + 1);
    } else {
      this.estimatedInServiceDate = null;
    }
    let isLighthouseProjectCheck = sessionStorage.getItem('isLighthouseProject');
    if (isLighthouseProjectCheck) {
      this.isLighthouseProject = isLighthouseProjectCheck;
    } else {
      this.isLighthouseProject = 'NO';
    }
    let primaryContactCheck = sessionStorage.getItem('primaryContact');
    if (primaryContactCheck) {
      this.primaryContact = JSON.parse(primaryContactCheck);
    } else {
      this.primaryContact = null;
    }
    let itSponsorCheck = sessionStorage.getItem('itSponsor');
    if (itSponsorCheck) {
      this.itSponsor = JSON.parse(itSponsorCheck);
    } else {
      this.itSponsor = null;
    }
    let omOnlycheck = sessionStorage.getItem('omOnly');
    this.omOnly = omOnlycheck ? omOnlycheck : null;

    let relatedWorkCheck = sessionStorage.getItem('relatedWork');
    this.relatedWork = relatedWorkCheck ? relatedWorkCheck : null;

    let hardwareOrSoftwareCheck = sessionStorage.getItem('hardwareOrSoftware');
    if (hardwareOrSoftwareCheck) {
      this.hardwareOrSoftware = hardwareOrSoftwareCheck;
    } else {
      this.hardwareOrSoftware = null;
    }
    let departmentCheck = sessionStorage.getItem('department');
    if (departmentCheck) {
      this.department = JSON.parse(departmentCheck);
      this.allocationDefaults = this.department.defaults;
      this.filteredAllocationDefaults = this.allocationDefaultsControl.valueChanges.pipe(
        startWith<string | any[]>(''),
        map((value) => (typeof value === 'string' ? value : this.lastFilter)),
        map((filter) => this.allocationDefaultFilter(filter))
      );
    } else {
      this.department = null;
    }
    let buildingInfoCheck = sessionStorage.getItem('buildingInfo');
    if (buildingInfoCheck) {
      this.buildingInfo = JSON.parse(buildingInfoCheck);
      this.buildingInfoControl = new FormControl();
    } else {
      this.buildingInfo = null;
      this.buildingInfoControl = new FormControl();
    }
    let distributeCostCheck = sessionStorage.getItem('distributeCost');
    if (distributeCostCheck) {
      this.distributeCost = JSON.parse(distributeCostCheck);
    } else {
      this.distributeCost = 'Manually';
    }
    let defaultOptionCheck = sessionStorage.getItem('defaultOption');
    if (defaultOptionCheck) {
      this.defaultOption = JSON.parse(defaultOptionCheck);
    } else {
      this.defaultOption = null;
    }
    let defaultOptionChoicesCheck = sessionStorage.getItem('defaultOptionChoices');
    if (defaultOptionChoicesCheck) {
      this.defaultOptionChoices = JSON.parse(defaultOptionChoicesCheck);
    } else {
      this.defaultOptionChoices = [];
    }
    let releaseDetailsCheck = sessionStorage.getItem('releaseDetails');
    if (releaseDetailsCheck) {
      this.releaseDetails = JSON.parse(releaseDetailsCheck);
    } else {
      this.releaseDetails = [new ReleaseDetail()];
    }
    let todayDateCheck = sessionStorage.getItem('todayDate');
    if (todayDateCheck) {
      this.todayDate = JSON.parse(todayDateCheck);
    } else {
      this.generateTodaysDate();
    }
    let allocationsCheck = sessionStorage.getItem('allocations');
    if (allocationsCheck) {
      this.operatingUnitControl = [];
      this.fundingProjectControl = [];
      this.stateControl = [];
      this.allocations = JSON.parse(allocationsCheck);
      for (let i = 0; i < this.allocations.length; i++) {
        this.operatingUnitControl.push(new FormControl());
        this.fundingProjectControl.push(new FormControl());
        this.stateControl.push(new FormControl());
        let matchFound = false;
        if (this.allocations[i].fundingProjectOptions) {
          for (let j = 0; j < this.allocations[i].fundingProjectOptions.length; j++) {
            if (
              this.allocations[i].fundingProjectOptions[j] &&
              this.allocations[i].fundingProjectID &&
              this.allocations[i].fundingProjectOptions[j].work_order_number ===
                this.allocations[i].fundingProjectID.work_order_number
            ) {
              matchFound = true;
              this.allocations[i].fundingProjectID = this.allocations[i].fundingProjectOptions[j];
            }
          }
        } else {
          if (
            this.allocations[i].operatingUnit &&
            this.allocations[i].operatingUnit.BUSINESS_UNIT
          ) {
            this.allocations[i].businessUnitValue = this.allocations[i].operatingUnit.BUSINESS_UNIT;
            this.setAllocationSetId(
              this.allocations[i],
              this.allocations[i].operatingUnit.BUSINESS_UNIT
            );
            this.getFundingProjectIDChoices(
              this.allocations[i],
              this.allocations[i].operatingUnit,
              i,
              false,
              true
            );
          } else {
            this.allocations[i].businessUnitValue = '';
          }
        }
      }
    } else {
      this.allocations = [new Allocation()];
      this.operatingUnitControl = [new FormControl()];
      this.fundingProjectControl = [new FormControl()];
      this.stateControl = [new FormControl()];
    }
    let buildingsCheck = sessionStorage.getItem('buildings');
    if (buildingsCheck) {
      this.buildingControl = [];
      this.filteredCostOptions = [];
      this.costControl = [];
      this.filteredUnitOfPropertyDescriptionOptions = [];
      this.unitOfPropertyDescriptionControl = [];
      this.buildings = JSON.parse(buildingsCheck);
      for (let i = 0; i < this.buildings.length; i++) {
        this.buildingControl.push(new FormControl());
        this.filteredCostOptions.push([]);
        this.costControl.push([]);
        this.filteredUnitOfPropertyDescriptionOptions.push([]);
        this.unitOfPropertyDescriptionControl.push([]);
        for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
          this.filteredCostOptions[i].push(new Observable<any[]>());
          this.costControl[i].push(new FormControl());
          this.filteredUnitOfPropertyDescriptionOptions[i].push(new Observable<any[]>());
          this.unitOfPropertyDescriptionControl[i].push(new FormControl());
          this.filteredUnitOfPropertyDescriptionOptions[i][
            this.filteredUnitOfPropertyDescriptionOptions[i].length - 1
          ] = this.unitOfPropertyDescriptionControl[i][
            this.unitOfPropertyDescriptionControl[i].length - 1
          ].valueChanges.pipe(
            startWith<string | any[]>(''),
            map((value) => (typeof value === 'string' ? value : this.lastFilter)),
            map((filter) => this.unitOfPropertyDescriptionFilter(filter))
          );
        }
      }
    } else {
      this.buildings = [new Building()];
      this.buildingControl = [new FormControl()];
      this.filteredCostOptions = [];
      this.costControl = [];
      this.filteredCostOptions.push([]);
      this.costControl.push([]);
      this.filteredUnitOfPropertyDescriptionOptions = [];
      this.unitOfPropertyDescriptionControl = [];
      this.filteredUnitOfPropertyDescriptionOptions.push([]);
      this.unitOfPropertyDescriptionControl.push([]);
      this.addMaterial(0);
    }
    let descriptionOptionsCheck = sessionStorage.getItem('descriptionOptions');
    if (descriptionOptionsCheck) {
      this.descriptionOptions = JSON.parse(descriptionOptionsCheck);
    } else {
      this.descriptionOptions = [];
    }
    let laborDetailsCheck = sessionStorage.getItem('laborDetails');
    if (laborDetailsCheck) {
      this.laborDetails = JSON.parse(laborDetailsCheck);
      this.filteredWorkTaskOptions = [];
      this.workTaskControl = [];
      this.filteredWorkDescriptionOptions = [];
      this.workDescriptionControl = [];
      this.filteredChargeTypeOptions = [];
      this.chargeTypeControl = [];
      for (let i = 0; i < this.laborDetails.length; i++) {
        this.filteredWorkTaskOptions.push(new Observable<string[]>());
        this.workTaskControl.push(new FormControl());
        this.filteredWorkTaskOptions[this.filteredWorkTaskOptions.length - 1] =
          this.workTaskControl[this.workTaskControl.length - 1].valueChanges.pipe(
            startWith<string | any[]>(''),
            map((value) => (typeof value === 'string' ? value : this.lastFilter)),
            map((filter) => this.workTaskFilter(filter))
          );
        this.filteredWorkDescriptionOptions.push(new Observable<any[]>());
        this.workDescriptionControl.push(new FormControl());
        this.filteredWorkDescriptionOptions[this.filteredWorkDescriptionOptions.length - 1] =
          this.workDescriptionControl[this.workDescriptionControl.length - 1].valueChanges.pipe(
            startWith<string | any[]>(''),
            map((value) => (typeof value === 'string' ? value : this.lastFilter)),
            map((filter) => this.workDescriptionFilter(filter, i))
          );
        this.filteredChargeTypeOptions.push(new Observable<string[]>());
        this.chargeTypeControl.push(new FormControl());
        this.filteredChargeTypeOptions[this.filteredChargeTypeOptions.length - 1] =
          this.chargeTypeControl[this.chargeTypeControl.length - 1].valueChanges.pipe(
            startWith<string | any[]>(''),
            map((value) => (typeof value === 'string' ? value : this.lastFilter)),
            map((filter) => this.chargeTypeFilter(filter))
          );
      }
    } else {
      this.laborDetails = [new LaborDetail()];
      this.filteredWorkTaskOptions = [new Observable<string[]>()];
      this.workTaskControl = [new FormControl()];
      this.filteredWorkDescriptionOptions = [new Observable<any[]>()];
      this.workDescriptionControl = [new FormControl()];
      this.filteredChargeTypeOptions = [new Observable<string[]>()];
      this.chargeTypeControl = [new FormControl()];
    }
    let contingencyDetailsCheck = sessionStorage.getItem('contingencyDetails');
    if (contingencyDetailsCheck) {
      this.contingencyDetails = JSON.parse(contingencyDetailsCheck);
      this.filteredContingencyCostOptions = [];
      this.contingencyCostControl = [];
      for (let i = 0; i < this.contingencyDetails.length; i++) {
        this.filteredContingencyCostOptions.push(new Observable<string[]>());
        this.contingencyCostControl.push(new FormControl());
        this.filteredContingencyCostOptions[i] = this.contingencyCostControl[i].valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) => this.contingencyCostFilter(filter))
        );
      }
    } else {
      this.contingencyDetails = [new ContingencyDetail()];
      this.filteredContingencyCostOptions = [new Observable<string[]>()];
      this.contingencyCostControl = [new FormControl()];
    }
    let operatingUnitCheck = sessionStorage.getItem('operatingUnit');
    if (operatingUnitCheck) {
      this.operatingUnit = JSON.parse(operatingUnitCheck);
    } else {
      this.operatingUnit = null;
    }
    let businessUnitCheck = sessionStorage.getItem('businessUnit');
    if (businessUnitCheck) {
      this.businessUnit = JSON.parse(businessUnitCheck);
    } else {
      this.businessUnit = null;
    }
    let businessUnitDescriptionCheck = sessionStorage.getItem('businessUnitDescription');
    if (businessUnitDescriptionCheck) {
      this.businessUnitDescription = JSON.parse(businessUnitDescriptionCheck);
    } else {
      this.businessUnitDescription = null;
    }
    let combinedBusinessUnitCheck = sessionStorage.getItem('combinedBusinessUnit');
    if (combinedBusinessUnitCheck) {
      this.combinedBusinessUnit = JSON.parse(combinedBusinessUnitCheck);
    } else {
      this.combinedBusinessUnit = null;
    }
    let uopDescriptionOptionsCheck = sessionStorage.getItem('uopDescriptionOptions');
    if (uopDescriptionOptionsCheck) {
      this.uopDescriptionOptions = JSON.parse(uopDescriptionOptionsCheck);
    } else {
      this.uopDescriptionOptions = [];
      this.getUOPDescriptionChoices();
    }
    let estimatedInServiceDateCheck = sessionStorage.getItem('estimatedInServiceDate');
    if (estimatedInServiceDateCheck) {
      this.estimatedInServiceDate = new Date(estimatedInServiceDateCheck);
      this.estimatedInServiceDate.setDate(this.estimatedInServiceDate.getDate() + 1);
    } else {
      this.estimatedInServiceDate = null;
    }
    let estimatedStartDateCheck = sessionStorage.getItem('estimatedStartDate');
    if (estimatedStartDateCheck) {
      this.estimatedStartDate = new Date(estimatedStartDateCheck);
      this.estimatedStartDate.setDate(this.estimatedStartDate.getDate() + 1);
    } else {
      this.estimatedStartDate = null;
    }
    let firstBuildingTouchedCheck = sessionStorage.getItem('firstBuildingTouched');
    if (firstBuildingTouchedCheck) {
      this.firstBuildingTouched = JSON.parse(firstBuildingTouchedCheck);
    } else {
      this.firstBuildingTouched = false;
    }
    let additionalCommentsCheck = sessionStorage.getItem('additionalComments');
    if (additionalCommentsCheck) {
      this.additionalComments = JSON.parse(additionalCommentsCheck);
    } else {
      this.additionalComments = null;
    }
    let additionalApproversCheck = sessionStorage.getItem('additionalApprovers');
    if (additionalApproversCheck) {
      this.additionalApprovers = JSON.parse(additionalApproversCheck);
      this.additionalApproverControl = [];
      for (let i = 0; i < this.additionalApprovers.length; i++) {
        this.additionalApproverControl.push(new FormControl());
      }
    } else {
      this.additionalApprovers = [];
      this.additionalApproverControl = [];
    }
    let approverListCheck = sessionStorage.getItem('approverList');
    if (approverListCheck) {
      this.approverList = JSON.parse(approverListCheck);
    } else {
      this.approverList = [];
    }
    let xmlDocCheck = sessionStorage.getItem('xmlDoc');
    if (xmlDocCheck) {
      this.xmlDoc = JSON.parse(xmlDocCheck);
    } else {
      this.xmlDoc = null;
    }
    let doaAmountsCheck = sessionStorage.getItem('doaAmounts');
    if (doaAmountsCheck) {
      this.doaAmounts = JSON.parse(doaAmountsCheck);
      this.getDOA(this.itSponsor.mailNickname, 0);
    } else {
      this.doaAmounts = [0];
      this.getDOA(this.itSponsor.mailNickname, 0);
    }
    let additionalApproverOptionsCheck = sessionStorage.getItem('additionalApproverOptions');
    if (additionalApproverOptionsCheck) {
      this.additionalApproverOptions = JSON.parse(additionalApproverOptionsCheck);
    } else {
      this.additionalApproverOptions = [];
    }
    let lastFilterCheck = sessionStorage.getItem('lastFilter');
    if (lastFilterCheck) {
      this.lastFilter = JSON.parse(lastFilterCheck);
    } else {
      this.lastFilter = null;
    }
    let filteredBuildingOptionsCheck = sessionStorage.getItem('filteredBuildingOptions');
    if (filteredBuildingOptionsCheck) {
      this.filteredBuildingOptions = JSON.parse(filteredBuildingOptionsCheck);
      this.filteredBuildingOptions = this.filteredBuildingOptions.slice(
        0,
        this.buildingControl.length
      );
      for (let i = 0; i < this.filteredBuildingOptions.length; i++) {
        this.filteredBuildingOptions[i] = this.buildingControl[i].valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) => this.buildingInfoFilter(filter))
        );
      }
    } else {
      this.filteredBuildingOptions = [];
      if (this.buildings && this.buildings.length > 0) {
        for (let i = 0; i < this.buildings.length; i++) {
          this.filteredBuildingOptions.push(
            this.buildingControl[i].valueChanges.pipe(
              startWith<string | any[]>(''),
              map((value) => (typeof value === 'string' ? value : this.lastFilter)),
              map((filter) => this.buildingInfoFilter(filter))
            )
          );
        }
      } else {
        if (!this.buildingControl || this.buildingControl.length === 0) {
          this.buildings = [new Building()];
          this.buildingControl = [new FormControl()];
          this.filteredCostOptions = [[]];
          this.costControl = [[]];
          this.filteredUnitOfPropertyDescriptionOptions = [[]];
          this.unitOfPropertyDescriptionControl = [[]];
          this.addMaterial(0);
        }
        this.filteredBuildingOptions = [new Observable<any[]>()];
        this.filteredBuildingOptions[0] = this.buildingControl[0].valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) => this.buildingInfoFilter(filter))
        );
      }
    }
    this.filteredOperatingUnitOptions = [];
    for (let i = 0; i < this.allocations.length; i++) {
      this.filteredOperatingUnitOptions.push(new Observable<any[]>());
      this.filteredOperatingUnitOptions[i] = this.operatingUnitControl[i].valueChanges.pipe(
        startWith<string | any[]>(''),
        map((value) => (typeof value === 'string' ? value : this.lastFilter)),
        map((filter) => this.operatingUnitFilter(filter))
      );
    }
    this.filteredFundingProjectOptions = [];
    for (let i = 0; i < this.allocations.length; i++) {
      this.filteredFundingProjectOptions.push(new Observable<any[]>());
      this.filteredFundingProjectOptions[i] = this.fundingProjectControl[i].valueChanges.pipe(
        startWith<string | any[]>(''),
        map((value) => (typeof value === 'string' ? value : this.lastFilter)),
        map((filter) => this.fundingProjectFilter(filter, this.allocations[i]))
      );
    }
    this.filteredStateOptions = [];
    for (let i = 0; i < this.allocations.length; i++) {
      this.filteredStateOptions.push(new Observable<any[]>());
      this.filteredStateOptions[i] = this.stateControl[i].valueChanges.pipe(
        startWith<string | any[]>(''),
        map((value) => (typeof value === 'string' ? value : this.lastFilter)),
        map((filter) => this.stateFilter(filter, this.allocations[i]))
      );
    }
    let filesCheck = sessionStorage.getItem('files');
    if (filesCheck) {
      this.files = JSON.parse(filesCheck);
    } else {
      this.files = [];
    }
    let workDescriptionsCheck = sessionStorage.getItem('workDescriptions');
    if (workDescriptionsCheck) {
      this.workDescriptions = JSON.parse(workDescriptionsCheck);
    } else {
      this.workDescriptions = [];
      if (laborDetailsCheck) {
        for (let i = 0; i < this.laborDetails.length; i++) {
          if (this.laborDetails[i].workTask.workDescriptions) {
            this.workDescriptions[i] = this.laborDetails[i].workTask.workDescriptions;
          } else {
            this.workDescriptions[i] = [];
          }
        }
      } else {
        this.workDescriptions.push([]);
      }
    }
    let allocationsTouchedCheck = sessionStorage.getItem('allocationsTouched');
    if (allocationsTouchedCheck) {
      this.allocationsTouched = JSON.parse(allocationsTouchedCheck);
    } else {
      this.allocationsTouched = false;
    }
    let hardwareSoftwareCheck = sessionStorage.getItem('previousHardwareOrSoftware');
    if (hardwareSoftwareCheck) {
      if (hardwareSoftwareCheck !== hardwareOrSoftwareCheck) {
        for (let i = 0; i < this.laborDetails.length; i++) {
          const detail = new LaborDetail();
          detail.workTask = null;
          detail.workDescription = null;
          detail.chargeType = this.laborDetails[i].chargeType;
          detail.totalCosts = this.laborDetails[i].totalCosts;
          this.laborDetails[i] = detail;
        }
        for (let i = 0; i < this.contingencyDetails.length; i++) {
          const detail = new ContingencyDetail();
          detail.cost = null;
          detail.description = null;
          detail.totalCosts = this.contingencyDetails[i].totalCosts;
          this.contingencyDetails[i] = detail;
        }
        this.filteredWorkTaskOptions = [new Observable<string[]>()];
        this.workTaskControl = [new FormControl()];
        this.filteredWorkDescriptionOptions = [new Observable<any[]>()];
        this.workDescriptionControl = [new FormControl()];
        this.filteredChargeTypeOptions = [new Observable<string[]>()];
        this.chargeTypeControl = [new FormControl()];
        this.filteredContingencyCostOptions = [new Observable<string[]>()];
        this.contingencyCostControl = [new FormControl()];
        this.clearUOPValues = true;
      }
    }
    if (!workDescriptionsCheck && !laborDetailsCheck) {
      if (this.hardwareOrSoftware === 'O&M Only') {
        this.laborDetails[0].workTask = {
          workTask: 'Labor-O&M',
          workDescriptions: ['Labor-O&M'],
        };
        this.workTaskChanged(
          {
            workTask: 'Labor-O&M',
            workDescriptions: ['Labor-O&M'],
          },
          0
        );
      }
    }
    let itSparGuidCheck = sessionStorage.getItem('itSparGuid');
    if (itSparGuidCheck) {
      this.itSparGuid = JSON.parse(itSparGuidCheck);
    } else {
      this.itSparGuid = '';
    }
    let patiProjectCheck = sessionStorage.getItem('patiProject');
    if (patiProjectCheck) {
      this.patiProject = JSON.parse(patiProjectCheck);
    } else {
      this.patiProject = null;
    }
    let projectNameCheck = sessionStorage.getItem('projectName');
    if (projectNameCheck) {
      this.projectName = projectNameCheck;
    } else {
      this.projectName = '';
    }
    let itProjectClassificationCheck = sessionStorage.getItem('itProjectClassification');
    if (itProjectClassificationCheck) {
      this.itProjectClassification = JSON.parse(itProjectClassificationCheck);
    } else {
      this.itProjectClassification = null;
    }
    let projectScopeDescriptionCheck = sessionStorage.getItem('projectScopeDescription');
    if (projectScopeDescriptionCheck) {
      this.projectScopeDescription = projectScopeDescriptionCheck;
    } else {
      this.projectScopeDescription = '';
    }
    let purchasingWarrantiesCheck = sessionStorage.getItem('purchasingWarranties');
    if (purchasingWarrantiesCheck) {
      this.purchasingWarranties = purchasingWarrantiesCheck;
    } else {
      this.purchasingWarranties = '';
    }
    let expectedLifeCheck = sessionStorage.getItem('expectedLife');
    if (expectedLifeCheck) {
      this.expectedLife = Number(expectedLifeCheck);
    } else {
      this.expectedLife = null;
    }
    let agileEffortCheck = sessionStorage.getItem('agileEffort');
    if (agileEffortCheck) {
      this.agileEffort = agileEffortCheck;
    } else {
      this.agileEffort = '';
    }
    let projectConsistsOfCheck = sessionStorage.getItem('projectConsistsOf');
    if (projectConsistsOfCheck) {
      this.projectConsistsOf = JSON.parse(projectConsistsOfCheck);
    } else {
      this.projectConsistsOf = [];
    }
    let softwareBeingUsedCheck = sessionStorage.getItem('softwareBeingUsed');
    if (softwareBeingUsedCheck) {
      this.softwareBeingUsed = softwareBeingUsedCheck;
    } else {
      this.softwareBeingUsed = '';
    }
    let softwareProjectOverviewCheck = sessionStorage.getItem('softwareProjectOverview');
    if (softwareProjectOverviewCheck) {
      this.softwareProjectOverview = softwareProjectOverviewCheck;
    } else {
      this.softwareProjectOverview = '';
    }
    let vendorNameCheck = sessionStorage.getItem('vendorName');
    if (vendorNameCheck) {
      this.vendorName = vendorNameCheck;
    } else {
      this.vendorName = '';
    }
    let softwareNameCheck = sessionStorage.getItem('softwareName');
    if (softwareNameCheck) {
      this.softwareName = softwareNameCheck;
    } else {
      this.softwareName = '';
    }
    let dataConversionActivitiesCheck = sessionStorage.getItem('dataConversionActivities');
    if (dataConversionActivitiesCheck) {
      this.dataConversionActivities = dataConversionActivitiesCheck;
    } else {
      this.dataConversionActivities = '';
    }
    let trainingCostsCheck = sessionStorage.getItem('trainingCosts');
    if (trainingCostsCheck) {
      this.trainingCosts = trainingCostsCheck;
    } else {
      this.trainingCosts = '';
    }
    let associatedRetirementCheck = sessionStorage.getItem('associatedRetirement');
    if (associatedRetirementCheck) {
      this.associatedRetirement = associatedRetirementCheck;
    } else {
      this.associatedRetirement = '';
    }
    let softwareToBeRetiredCheck = sessionStorage.getItem('softwareToBeRetired');
    if (softwareToBeRetiredCheck) {
      this.softwareToBeRetired = softwareToBeRetiredCheck;
    } else {
      this.softwareToBeRetired = '';
    }
    let retiredInServiceDateCheck = sessionStorage.getItem('retiredInServiceDate');
    if (retiredInServiceDateCheck) {
      this.retiredInServiceDate = retiredInServiceDateCheck;
    } else {
      this.retiredInServiceDate = '';
    }
    let replacingInterfacesCheck = sessionStorage.getItem('replacingInterfaces');
    if (replacingInterfacesCheck) {
      this.replacingInterfaces = replacingInterfacesCheck;
    } else {
      this.replacingInterfaces = '';
    }
    let inServiceYearCheck = sessionStorage.getItem('inServiceYear');
    if (inServiceYearCheck) {
      this.inServiceYear = inServiceYearCheck;
    } else {
      this.inServiceYear = '';
    }
    let maintenanceContractsCheck = sessionStorage.getItem('maintenanceContracts');
    if (maintenanceContractsCheck) {
      this.maintenanceContracts = maintenanceContractsCheck;
    } else {
      this.maintenanceContracts = '';
    }
    let perpetualLicensesCheck = sessionStorage.getItem('perpetualLicenses');
    if (perpetualLicensesCheck) {
      this.perpetualLicenses = perpetualLicensesCheck;
    } else {
      this.perpetualLicenses = '';
    }
    let contractualRightCheck = sessionStorage.getItem('contractualRight');
    if (contractualRightCheck) {
      this.contractualRight = contractualRightCheck;
    } else {
      this.contractualRight = '';
    }
    let significantPenaltyCheck = sessionStorage.getItem('significantPenalty');
    if (significantPenaltyCheck) {
      this.significantPenalty = significantPenaltyCheck;
    } else {
      this.significantPenalty = '';
    }
    let isFeasibleCheck = sessionStorage.getItem('isFeasible');
    if (isFeasibleCheck) {
      this.isFeasible = isFeasibleCheck;
    } else {
      this.isFeasible = '';
    }
    let serviceFeesCheck = sessionStorage.getItem('serviceFees');
    if (serviceFeesCheck) {
      this.serviceFees = serviceFeesCheck;
    } else {
      this.serviceFees = '';
    }
    let useWithoutPayingCheck = sessionStorage.getItem('useWithoutPaying');
    if (useWithoutPayingCheck) {
      this.useWithoutPaying = useWithoutPayingCheck;
    } else {
      this.useWithoutPaying = '';
    }
    let howSoftwareReleasedCheck = sessionStorage.getItem('howSoftwareReleased');
    if (howSoftwareReleasedCheck) {
      this.howSoftwareReleased = howSoftwareReleasedCheck;
    } else {
      this.howSoftwareReleased = '';
    }
    let draftSavedCheck = sessionStorage.getItem('draftSaved');
    if (draftSavedCheck) {
      this.draftSaved = draftSavedCheck;
    } else {
      this.draftSaved = '';
    }
    let draftSavedDayCheck = sessionStorage.getItem('draftSavedDay');
    if (draftSavedDayCheck) {
      this.draftSavedDay = draftSavedDayCheck;
    } else {
      this.draftSavedDay = '';
    }
    let draftSavedTimeCheck = sessionStorage.getItem('draftSavedTime');
    if (draftSavedTimeCheck) {
      this.draftSavedTime = draftSavedTimeCheck;
    } else {
      this.draftSavedTime = '';
    }
    let isRevisionIndicatorCheck = sessionStorage.getItem('isRevisionIndicator');
    if (isRevisionIndicatorCheck === 'true') {
      this.isRevisionIndicator = true;
    } else {
      this.isRevisionIndicator = false;
    }
    let formNumberCheck = sessionStorage.getItem('formNumber');
    if (formNumberCheck) {
      this.formNumber = formNumberCheck;
    } else {
      this.formNumber = '';
    }
    let displayRevisionNumberCheck = sessionStorage.getItem('displayRevisionNumber');
    if (displayRevisionNumberCheck) {
      this.displayRevisionNumber = Number(displayRevisionNumberCheck);
    } else {
      this.displayRevisionNumber = 0;
    }
    let previousCapitalSubtotalCheck = sessionStorage.getItem('previousCapitalSubtotal');
    if (previousCapitalSubtotalCheck) {
      this.previousCapitalSubtotal = Number(previousCapitalSubtotalCheck);
    } else {
      this.previousCapitalSubtotal = 0;
    }
    let previousOMSubtotalCheck = sessionStorage.getItem('previousOMSubtotal');
    if (previousOMSubtotalCheck) {
      this.previousOMSubtotal = Number(previousOMSubtotalCheck);
    } else {
      this.previousOMSubtotal = 0;
    }
    let etsPacAssignmentCheck = sessionStorage.getItem('etsPacAssignment');
    if (etsPacAssignmentCheck) {
      this.etsPacAssignment = JSON.parse(etsPacAssignmentCheck);
    } else {
      this.etsPacAssignment = null;
    }
  }

  base64ImageToBlob(str) {
    // extract content type and base64 payload from original string
    let pos = str.indexOf(';base64,');
    let type = str.substring(5, pos);
    let b64 = str.substr(pos + 8);

    // decode base64
    let imageContent = atob(b64);

    // create an ArrayBuffer and a view (as unsigned 8-bit)
    let buffer = new ArrayBuffer(imageContent.length);
    let view = new Uint8Array(buffer);

    // fill the view, using the decoded base64
    for (let n = 0; n < imageContent.length; n++) {
      view[n] = imageContent.charCodeAt(n);
    }

    // convert ArrayBuffer to Blob
    let blob = new Blob([buffer], { type: type });

    return blob;
  }

  projectIDDisabled() {
    return this.isLighthouseProject === 'NO';
  }

  assignBuilding(value: any) {
    if (
      (this.buildings.length > 0 && !this.firstBuildingTouched) ||
      this.isExtraBuilding(value) ||
      this.isExtraBuilding(this.buildings[0].buildingName)
    ) {
      this.buildings[0].buildingName = value;
    }
    if (this.isExtraBuilding(value)) {
      this.buildings = [this.buildings[0]];
      if (this.buildingControl.length > 0) this.buildingControl = [this.buildingControl[0]];
      if (this.filteredBuildingOptions.length > 0)
        this.filteredBuildingOptions = [this.filteredBuildingOptions[0]];
    }
    if (!this.allocationsTouched && !this.isRevisionIndicator) {
      let matchFound = false;
      for (let i = 0; i < this.operatingUnitOptions.length && !matchFound; i++) {
        if (this.hardwareOrSoftware === 'O&M Only') {
          if (value.NewOMOUs === this.operatingUnitOptions[i].OPERATING_UNIT) {
            this.allocations[0].operatingUnit = this.operatingUnitOptions[i];
            matchFound = true;
          }
        } else {
          if (value.NewCapOUs === this.operatingUnitOptions[i].OPERATING_UNIT) {
            this.allocations[0].operatingUnit = this.operatingUnitOptions[i];
            matchFound = true;
          }
        }
        if (matchFound) {
          this.setBusinessUnit(this.allocations[0], this.allocations[0].operatingUnit, 0);
          this.getFundingProjectIDChoices(
            this.allocations[0],
            this.allocations[0].operatingUnit,
            0
          );
          this.getUOPDescriptionChoices();
        }
      }
    }
  }

  assignAllocationDefaults(value: any) {
    this.allocationDefaults = value.defaults;
    this.filteredAllocationDefaults = this.allocationDefaultsControl.valueChanges.pipe(
      startWith<string | any[]>(''),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.allocationDefaultFilter(filter))
    );
  }

  isExtraBuilding(value: any) {
    if (!value || typeof value !== 'object') {
      return false;
    }
    for (let i = 0; i < this.extraBuildings.length; i++) {
      if (value.BuildingName === this.extraBuildings[i]) {
        return true;
      }
    }
    return false;
  }

  setBuildingAsTouched(index: any) {
    if (index === 0) {
      this.firstBuildingTouched = true;
    }
  }

  setDefaultAllocation(value: any) {
    let allocationSet = null;
    for (let i = 0; i < this.allocationDefaultList.length; i++) {
      if (value === this.allocationDefaultList[i].default) {
        allocationSet = this.allocationDefaultList[i];
      }
    }
    this.allocations = [];
    for (let i = 0; i < allocationSet.allocations.length; i++) {
      this.allocations.push(new Allocation());
      this.operatingUnitControl.push(new FormControl());
      this.fundingProjectControl.push(new FormControl());
      this.stateControl.push(new FormControl());
      this.filteredOperatingUnitOptions.push(new Observable<OperatingUnit[]>());
      this.filteredOperatingUnitOptions[this.filteredOperatingUnitOptions.length - 1] =
        this.operatingUnitControl[this.operatingUnitControl.length - 1].valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) => this.operatingUnitFilter(filter))
        );
      this.filteredFundingProjectOptions.push(new Observable<any[]>());
      this.filteredFundingProjectOptions[this.filteredFundingProjectOptions.length - 1] =
        this.fundingProjectControl[this.fundingProjectControl.length - 1].valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) =>
            this.fundingProjectFilter(filter, this.allocations[this.allocations.length - 1])
          )
        );
      this.filteredStateOptions.push(new Observable<any[]>());
      this.filteredStateOptions[this.filteredStateOptions.length - 1] = this.stateControl[
        this.stateControl.length - 1
      ].valueChanges.pipe(
        startWith<string | any[]>(''),
        map((value) => (typeof value === 'string' ? value : this.lastFilter)),
        map((filter) => this.stateFilter(filter, this.allocations[this.allocations.length - 1]))
      );
      let matchFound = false;
      for (let j = 0; j < this.operatingUnitOptions.length && !matchFound; j++) {
        if (
          this.operatingUnitOptions[j].OPERATING_UNIT.startsWith(
            allocationSet.allocations[i].operatingUnit
          )
        ) {
          matchFound = true;
          this.allocations[i].operatingUnit = this.operatingUnitOptions[j];
          this.allocations[i].businessUnitValue = this.operatingUnitOptions[j].BUSINESS_UNIT;
          this.allocations[i].businessUnit = this.operatingUnitOptions[j].BUSINESS_UNIT.concat(
            ' - '
          ).concat(this.operatingUnitOptions[j].BU_DESCR);
          this.setAllocationSetId(this.allocations[i], this.operatingUnitOptions[j].BUSINESS_UNIT);
          let matchFoundState = false;
          for (let k = 0; k < this.buForStateOptions.length && !matchFoundState; k++) {
            if (this.allocations[i].businessUnitValue === this.buForStateOptions[k]) {
              matchFoundState = true;
              this.allocations[i].stateOptions = ['NC', 'SC', 'NC & SC'];
            }
          }
          if (!matchFound) {
            this.allocations[i].stateOptions = [];
          }
          this.filteredStateOptions[i] = this.stateControl[i].valueChanges.pipe(
            startWith<string | any[]>(''),
            map((value) => (typeof value === 'string' ? value : this.lastFilter)),
            map((filter) => this.stateFilter(filter, this.allocations[i]))
          );
        }
      }
      this.allocations[i].percentage = Number(allocationSet.allocations[i].percentage);
      //this.allocations[i].fundingProjectID = value.allocations[i].fundingProject;
      this.getFundingProjectIDChoices(
        this.allocations[i],
        this.allocations[i].businessUnitValue,
        i,
        true
      );
      //this.getProjectClassChoices(this.allocations[i], this.allocations[i].businessUnitValue, true);
      //this.getProjectTypeChoices(this.allocations[i], this.allocations[i].businessUnitValue, true);
      this.getUOPDescriptionChoices();
    }
  }

  distributeCostChange(value: any) {
    if (value !== 'Default') {
      this.defaultOption = null;
      this.allocations = [new Allocation()];
      this.allocationsTouched = false;
      this.filteredAllocationDefaults = this.allocationDefaultsControl.valueChanges.pipe(
        startWith<string | any[]>(''),
        map((value) => (typeof value === 'string' ? value : this.lastFilter)),
        map((filter) => this.allocationDefaultFilter(filter))
      );
      if (this.buildingInfo && this.buildingInfo.OMOperatingUnits) {
        let matchFound = false;
        for (let i = 0; i < this.operatingUnitOptions.length && !matchFound; i++) {
          if (this.hardwareOrSoftware === 'O&M Only') {
            if (this.buildingInfo.NewOMOUs === this.operatingUnitOptions[i].OPERATING_UNIT) {
              this.allocations[0].operatingUnit = this.operatingUnitOptions[i];
              matchFound = true;
            }
          } else {
            if (this.buildingInfo.NewCapOUs === this.operatingUnitOptions[i].OPERATING_UNIT) {
              this.allocations[0].operatingUnit = this.operatingUnitOptions[i];
              matchFound = true;
            }
          }
          if (matchFound) {
            this.setBusinessUnit(this.allocations[0], this.allocations[0].operatingUnit, 0);
            this.getFundingProjectIDChoices(
              this.allocations[0],
              this.allocations[0].operatingUnit,
              0
            );
            this.getUOPDescriptionChoices();
          }
        }
      }
    }
  }

  stateDisabled(allocation: Allocation) {
    if (!this.buildingInfo || this.buildingInfo.BuildingName !== 'IT POP') {
      return true;
    } else {
      return allocation.stateOptions.length === 0;
    }
  }

  /*searchUsersApprover(searchText: string) {
    this.dataService.searchUsers(searchText).subscribe((result) => {
      this.approverOptions = _.sortBy(result['value'], ['surname']);
    });
  }*/

  getDOA(lanID: string, index: number) {
    this.doaAmounts[index] = 0;
    let doc = document.implementation.createDocument('', '', null);
    const pi = doc.createProcessingInstruction('xml', 'version="1.0" encoding="UTF-8"');
    doc.insertBefore(pi, doc.firstChild);
    let elem1 = doc.createElement('soapenv:Envelope');
    elem1.setAttribute('xmlns:soapenv', 'http://schemas.xmlsoap.org/soap/envelope/');
    elem1.setAttribute('xmlns:web', 'http://duke-energy.com/webservices/');
    let elem2 = doc.createElement('soapenv:Header');
    let elem3 = doc.createElement('soapenv:Body');
    let elem4 = doc.createElement('web:GetDoaInformationByLanid');
    let elem5 = doc.createElement('web:lanids');
    let elem6 = doc.createElement('web:string');
    elem6.innerHTML = lanID;
    elem5.appendChild(elem6);
    elem4.appendChild(elem5);
    elem3.appendChild(elem4);
    elem1.appendChild(elem2);
    elem1.appendChild(elem3);
    doc.appendChild(elem1);
    let finalString = doc.documentElement.outerHTML;
    this.dataService.getDOA(finalString).subscribe(
      (result) => {
        this.xmlDoc = this.parser.parseFromString(result, 'text/xml');
        if (this.xmlDoc.getElementsByTagName('StatusCode')[0].innerHTML === 'ERROR') {
          /*let dataStructure;
        let error = this.xmlDoc.getElementsByTagName("StatusCodeMsg")[0].innerHTML;
        dataStructure = {
          error: true,
          data: error,
          isDOA: true
        }
        this.dialog.open(SuccessDialogComponent, {
          disableClose: true,
          data: dataStructure
        });*/
          this.doaAmounts[index] = 0;
          console.log('error');
          let errorType = 'Get DOA Error';
          let errorDescription = '';
          errorDescription = errorDescription.concat(
            'Get DOA Error Returned from Endpoint - ' +
              this.xmlDoc.getElementsByTagName('StatusCodeMsg')[0].innerHTML +
              ' - LAN ID: ' +
              lanID
          );
          let dataStructure = {
            errorType: errorType,
            errorDescription: errorDescription,
          };
          this.dialog.open(ErrorDialogComponent, {
            data: dataStructure,
            disableClose: true,
          });
        } else {
          this.doaAmounts[index] = Number(this.xmlDoc.getElementsByTagName('Amount')[0].innerHTML);
        }
      },
      (error) => {
        this.doaAmounts[index] = 0;
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat('Get DOA Error - ', error.error.message);
        } else {
          errorDescription = errorDescription.concat('Get DOA Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  displayFnAdditionalApprover(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    } else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    } else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    } else {
      return value;
    }
  }

  displayFnOperatingUnit(value: OperatingUnit): any | undefined {
    if (!value) {
      return '';
    } else {
      return value.OPERATING_UNIT + ' - ' + value.DESCR;
    }
  }

  displayFnFundingProject(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value.work_order_number;
    }
  }

  displayFnState(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value;
    }
  }

  displayFnCost(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value;
    }
  }

  displayFnUnitOfPropertyDescription(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value;
    }
  }

  displayFnDepartment(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value.department;
    }
  }

  displayFnDistributeCost(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value;
    }
  }

  displayFnAllocationDefaults(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value;
    }
  }

  displayFnWorkTask(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value.workTask;
    }
  }

  displayFnWorkDescription(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value;
    }
  }

  displayFnChargeType(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value;
    }
  }

  displayFnContingencyCost(value: any): any | undefined {
    if (!value) {
      return '';
    } else {
      return value;
    }
  }

  addNewAdditionalApprover() {
    this.additionalApproverControl.push(new FormControl());
    this.additionalApprovers.push(null);
    this.additionalApproverOptions.push([]);
    this.approverList.push('');
    this.doaAmounts.push(0);
  }

  deleteApprover(index: number) {
    this.additionalApproverControl.splice(index, 1);
    this.additionalApprovers.splice(index, 1);
    this.additionalApproverOptions.splice(index, 1);
    this.approverList.splice(index, 1);
    this.doaAmounts.splice(index + 1, 1);
  }

  searchUsersAdditionalApprover(searchText: any, index: number) {
    this.dataService.searchUsers(searchText, { excludeContractors: true }).subscribe((result) => {
      this.additionalApproverOptions[index] = _.orderBy(result['value'], ['surname', 'givenName']);
      document.getElementsByName(this.autocompleteName(index))[0].focus();
    });
  }

  additionalApproverSelected(event: any, index: number) {
    this.getDOA(event.mailNickname, index + 1);
    this.approverList[index] = event;
  }

  autocompleteName(index: number) {
    return 'additionalApprover' + index.toString();
  }

  fundingProjectIDDisabled(allocation: Allocation, index: number) {
    return (
      this.isRevisionIndicator ||
      !allocation.fundingProjectOptions ||
      allocation.fundingProjectOptions.length === 0 ||
      this.isRepeatedOperatingUnit(index)
    );
  }

  isRepeatedOperatingUnit(index: number) {
    for (let i = 0; i < this.allocations.length; i++) {
      if (
        ((this.allocations[index].businessUnitValue === this.allocations[i].businessUnitValue &&
          this.allocations[index].businessUnitValue !== '20048' &&
          this.allocations[index].businessUnitValue !== '50125') ||
          (this.allocations[index].businessUnitValue === this.allocations[i].businessUnitValue &&
            (this.allocations[index].businessUnitValue === '20048' ||
              this.allocations[index].businessUnitValue === '50125') &&
            this.allocations[index].operatingUnit.OPERATING_UNIT ===
              this.allocations[i].operatingUnit.OPERATING_UNIT)) &&
        i < index
      ) {
        return true;
      }
    }
    return false;
  }

  projectClassDisabled(allocation: Allocation) {
    return !allocation.projectClassOptions || allocation.projectClassOptions.length === 0;
  }

  projectTypeDisabled(allocation: Allocation) {
    return !allocation.projectTypeOptions || allocation.projectTypeOptions.length === 0;
  }

  uopDescriptionDisabled() {
    return !this.uopDescriptionOptions || this.uopDescriptionOptions.length === 0;
  }

  isEmployeeContractorRequired() {
    // If O&M, labor row is required if neither materials or labor have an entry
    if (this.hardwareOrSoftware === 'O&M Only') {
      return !this.materialsHasEntry() && !this.employeeContractorHasEntry();
    }
    // If Software, CAP labor required if there is no CAP material entry
    if (this.hardwareOrSoftware === 'Software Only') {
      return !this.materialHasCapital() && !this.laborHasCapitalSoftware();
    }
    // If Hardware & Software, labor required if there is no CAP material or CAP labor software entry
    if (this.hardwareOrSoftware === 'Hardware and Software') {
      return !this.materialsHasEntry() && !this.laborHasCapitalSoftware();
    }
    // if Hardware only, labor is only required if the row is partially filled out (default)
    return !this.employeeContractorFilledOut();
  }

  isContingencyRowMissing(index: number, row: string) {
    if (
      this.showErrorsDisclaimer &&
      (this.contingencyDetails[index].cost ||
        this.contingencyDetails[index].description ||
        this.contingencyDetails[index].totalCosts)
    ) {
      if (row === 'cost') {
        if (!this.contingencyDetails[index].cost) {
          return true;
        }
      }
      if (row === 'description') {
        if (!this.contingencyDetails[index].description) {
          return true;
        }
      }
      if (row === 'totalCosts') {
        if (!this.contingencyDetails[index].totalCosts) {
          return true;
        }
      }
    }
  }

  isMaterialRequired() {
    // If O&M, material row is required if neither materials or labor have an entry
    if (this.hardwareOrSoftware === 'O&M Only') {
      return !this.materialsHasEntry() && !this.employeeContractorHasEntry();
    }
    // If Hardware, one CAP material is always required
    if (this.hardwareOrSoftware === 'Hardware Only') {
      return !this.materialHasCapital();
    }
    // If Software, CAP material required if there is not a CAP labor entry
    if (this.hardwareOrSoftware === 'Software Only') {
      return !this.materialHasCapital() && !this.laborHasCapitalSoftware();
    }
    // If Hardware & Software, one row in materials always required, plus a 2nd row required if no CAP software labor entry
    if (this.hardwareOrSoftware === 'Hardware and Software') {
      return !this.materialsHasEntry() && !this.laborHasCapitalSoftware();
    }

    return !this.materialsFilledOut();
  }

  reviewDisabled() {
    if (
      this.department &&
      this.department.department &&
      this.buildingInfo &&
      this.buildingInfo.BuildingName
    ) {
      if (
        (!(this.hardwareOrSoftware === 'Hardware Only' || this.hardwareOrSoftware === 'O&M Only') &&
          this.capabilityReleaseFilledOut()) ||
        this.hardwareOrSoftware === 'Hardware Only' ||
        this.hardwareOrSoftware === 'O&M Only'
      ) {
        if (
          this.distributeCost === 'Manually' ||
          (this.distributeCost === 'Default' && this.defaultOption)
        ) {
          if (
            this.allocationsFilledOut() &&
            this.allocationTotal() == 100 &&
            !this.multipleNuclearHardwareSoftware() &&
            !this.emptyAllocationLine()
          ) {
            if (
              this.materialsFilledOut() &&
              this.employeeContractorFilledOut() &&
              this.contingencyFilledOut()
            ) {
              if (
                ((this.hardwareOrSoftware === 'Hardware Only' ||
                  this.hardwareOrSoftware === 'Hardware and Software') &&
                  this.materialsHasEntry()) ||
                ((this.hardwareOrSoftware === 'Software Only' ||
                  this.hardwareOrSoftware === 'O&M Only') &&
                  (this.materialsHasEntry() ||
                    this.employeeContractorHasEntry() ||
                    this.contingencyHasEntry()))
              ) {
                if (this.approversFilledOut()) {
                  return false;
                }
              }
            }
          }
        }
      }
    }
    return true;
  }

  approversFilledOut() {
    for (let i = 0; i < this.approverList.length; i++) {
      if (!(this.approverList[i] && this.approverList[i].displayName)) {
        return false;
      }
    }
    return true;
  }

  capabilityReleaseFilledOut() {
    for (let i = 0; i < this.releaseDetails.length; i++) {
      for (let j = 0; j < this.releaseDetails[i].capabilityDetails.length; j++) {
        if (i === 0) {
          if (j === 0) {
            if (
              !(
                !this.releaseDetails[i].capabilityDetails[j].releaseNumber &&
                !this.releaseDetails[i].capabilityDetails[j].releaseDate &&
                !this.releaseDetails[i].capabilityDetails[j].capabilities &&
                !this.releaseDetails[i].capabilityDetails[j].description
              )
            ) {
              if (
                !this.releaseDetails[i].capabilityDetails[j].releaseNumber ||
                !this.releaseDetails[i].capabilityDetails[j].releaseDate ||
                !this.releaseDetails[i].capabilityDetails[j].capabilities ||
                !this.releaseDetails[i].capabilityDetails[j].description
              ) {
                return false;
              }
            }
          } else if (
            !this.releaseDetails[i].capabilityDetails[j].capabilities ||
            !this.releaseDetails[i].capabilityDetails[j].description
          ) {
            return false;
          }
        } else {
          if (j === 0) {
            if (
              !this.releaseDetails[i].capabilityDetails[j].releaseNumber ||
              !this.releaseDetails[i].capabilityDetails[j].releaseDate ||
              !this.releaseDetails[i].capabilityDetails[j].capabilities ||
              !this.releaseDetails[i].capabilityDetails[j].description
            ) {
              return false;
            }
          } else if (
            !this.releaseDetails[i].capabilityDetails[j].capabilities ||
            !this.releaseDetails[i].capabilityDetails[j].description
          ) {
            return false;
          }
        }
      }
    }
    return true;
  }

  allocationsFilledOut() {
    for (let i = 0; i < this.allocations.length; i++) {
      if (
        !(
          this.allocations[i].operatingUnit &&
          this.allocations[i].operatingUnit.OPERATING_UNIT &&
          this.allocations[i].fundingProjectID &&
          this.allocations[i].fundingProjectID.work_order_number
        )
      ) {
        return false;
      } else {
        if (!this.stateDisabled(this.allocations[i])) {
          if (!this.allocations[i].state) {
            return false;
          }
        }
      }
    }
    return true;
  }

  materialsFilledOut() {
    for (let i = 0; i < this.buildings.length; i++) {
      if (i > 0) {
        if (
          !(
            this.buildings[i] &&
            this.buildings[i].buildingName &&
            this.buildings[i].buildingName.BuildingName
          )
        ) {
          return false;
        }
      }
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        if (i === 0 && j === 0) {
          if (
            !(
              !this.buildings[i].materialEstimates[j].cost &&
              !this.buildings[i].materialEstimates[j].unitOfPropertyDetails &&
              this.buildings[i].materialEstimates[j].cost !== 'O&M' &&
              !this.buildings[i].materialEstimates[j].unitOfPropertyDescription &&
              !this.buildings[i].materialEstimates[j].quantity &&
              !this.buildings[i].materialEstimates[j].unitCosts
            )
          ) {
            if (
              !this.buildings[i].materialEstimates[j].cost ||
              !this.buildings[i].materialEstimates[j].unitOfPropertyDetails ||
              (this.buildings[i].materialEstimates[j].cost !== 'O&M' &&
                !this.buildings[i].materialEstimates[j].unitOfPropertyDescription) ||
              !this.buildings[i].materialEstimates[j].quantity ||
              !this.buildings[i].materialEstimates[j].unitCosts ||
              this.tangiblePropertyCheck(this.buildings[i].materialEstimates[j]) ||
              this.tangibleTotalCostCheck(this.buildings[i].materialEstimates[j]) ||
              this.tangibleDateCheck(this.buildings[i].materialEstimates[j])
            ) {
              return false;
            }
          }
        } else {
          if (
            !this.buildings[i].materialEstimates[j].cost ||
            !this.buildings[i].materialEstimates[j].unitOfPropertyDetails ||
            (this.buildings[i].materialEstimates[j].cost !== 'O&M' &&
              !this.buildings[i].materialEstimates[j].unitOfPropertyDescription) ||
            !this.buildings[i].materialEstimates[j].quantity ||
            !this.buildings[i].materialEstimates[j].unitCosts ||
            this.tangiblePropertyCheck(this.buildings[i].materialEstimates[j]) ||
            this.tangibleTotalCostCheck(this.buildings[i].materialEstimates[j]) ||
            this.tangibleDateCheck(this.buildings[i].materialEstimates[j])
          ) {
            return false;
          }
        }
      }
    }
    return true;
  }

  laborHasCapitalSoftware() {
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (
        this.laborDetails[i].workTask &&
        this.laborDetails[i].workTask.workTask === 'Software-CAP'
      ) {
        return true;
      }
    }
    return false;
  }

  materialHasCapital() {
    for (let i = 0; i < this.buildings.length; i++) {
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        if (this.buildings[i].materialEstimates[j].cost === 'CAP') {
          return true;
        }
      }
    }
    return false;
  }

  materialHasCapitalSoftware() {
    for (let i = 0; i < this.buildings.length; i++) {
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        const materialEstimate = this.buildings[i].materialEstimates[j];
        if (
          materialEstimate.cost === 'CAP' &&
          materialEstimate.unitOfPropertyDescription &&
          materialEstimate.unitOfPropertyDescription.includes('Software')
        ) {
          return true;
        }
      }
    }
    return false;
  }

  materialHasCapitalHardware() {
    for (let i = 0; i < this.buildings.length; i++) {
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        const materialEstimate = this.buildings[i].materialEstimates[j];
        if (
          materialEstimate.cost === 'CAP' &&
          materialEstimate.unitOfPropertyDescription &&
          !materialEstimate.unitOfPropertyDescription.includes('Software')
        ) {
          return true;
        }
      }
    }
    return false;
  }

  materialsHasEntry() {
    for (let i = 0; i < this.buildings.length; i++) {
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        const cost = this.buildings[i].materialEstimates[j].cost;
        if (
          cost &&
          this.buildings[i].materialEstimates[j].unitOfPropertyDetails &&
          this.buildings[i].materialEstimates[j].quantity &&
          this.buildings[i].materialEstimates[j].unitCosts
        ) {
          if (cost === 'O&M') {
            return true;
          }
          if (cost !== 'O&M' && this.buildings[i].materialEstimates[j].unitOfPropertyDescription) {
            return true;
          }
        }
      }
    }
    return false;
  }

  employeeContractorFilledOut() {
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (i === 0) {
        if (
          !(
            !(this.laborDetails[i].workTask && this.laborDetails[i].workTask.workTask) &&
            !this.laborDetails[i].workDescription &&
            !this.laborDetails[i].chargeType &&
            !this.laborDetails[i].totalCosts
          )
        ) {
          if (
            !(this.laborDetails[i].workTask && this.laborDetails[i].workTask.workTask) ||
            !this.laborDetails[i].workDescription ||
            !this.laborDetails[i].chargeType ||
            !this.laborDetails[i].totalCosts
          ) {
            return false;
          }
        }
      } else {
        if (
          !(this.laborDetails[i].workTask && this.laborDetails[i].workTask.workTask) ||
          !this.laborDetails[i].workDescription ||
          !this.laborDetails[i].chargeType ||
          !this.laborDetails[i].totalCosts
        ) {
          return false;
        }
      }
    }
    return true;
  }

  employeeContractorHasEntry() {
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (
        this.laborDetails[i].workTask &&
        this.laborDetails[i].workTask.workTask &&
        this.laborDetails[i].workDescription &&
        this.laborDetails[i].chargeType &&
        this.laborDetails[i].totalCosts
      ) {
        return true;
      }
    }
    return false;
  }

  contingencyFilledOut() {
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      if (i === 0) {
        if (
          !(
            !this.contingencyDetails[i].cost &&
            !this.contingencyDetails[i].description &&
            !this.contingencyDetails[i].totalCosts
          )
        ) {
          if (
            !this.contingencyDetails[i].cost ||
            !this.contingencyDetails[i].description ||
            !this.contingencyDetails[i].totalCosts
          ) {
            return false;
          }
        }
      } else {
        if (
          !this.contingencyDetails[i].cost ||
          !this.contingencyDetails[i].description ||
          !this.contingencyDetails[i].totalCosts
        ) {
          return false;
        }
      }
    }
    return true;
  }

  contingencyHasEntry() {
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      if (
        this.contingencyDetails[i].cost &&
        this.contingencyDetails[i].description &&
        this.contingencyDetails[i].totalCosts
      ) {
        return true;
      }
    }
    return false;
  }

  doaAmountMet() {
    for (let i = 0; i < this.doaAmounts.length; i++) {
      if (this.doaAmounts[i] >= this.totalProjectCost()) {
        return true;
      }
    }
    return false;
  }

  previousPage() {
    //this.clearSessionProjectData();
    this.saveProjectData();
    this.router.navigate(['/it-project-setup']);
  }

  exitPage() {
    //this.clearSessionProjectData();
    this.router.navigate(['/dashboard']);
  }

  confirmAndContinue(form: NgForm) {
    // check Building Info for validity
    if (!(this.buildingInfo && this.buildingInfo.BuildingName)) {
      this.buildingInfoControl.setErrors({ invalidContact: true });
    } else {
      this.buildingInfoControl.setErrors(null);
    }
    // check Operating Units for validity
    for (let i = 0; i < this.allocations.length; i++) {
      if (
        !(this.allocations[i].operatingUnit && this.allocations[i].operatingUnit.OPERATING_UNIT)
      ) {
        this.operatingUnitControl[i].setErrors({ invalidContact: true });
      } else {
        this.operatingUnitControl[i].setErrors(null);
      }
    }
    // check Funding Project IDs for validity
    for (let i = 0; i < this.allocations.length; i++) {
      if (
        !(
          this.allocations[i].fundingProjectID &&
          this.allocations[i].fundingProjectID.work_order_number
        )
      ) {
        this.fundingProjectControl[i].setErrors({ invalidContact: true });
      } else {
        this.fundingProjectControl[i].setErrors(null);
      }
    }
    // check Building for validity
    for (let i = 0; i < this.buildingControl.length; i++) {
      if (
        !this.isExtraBuilding(this.buildings[i].buildingName) &&
        !(
          this.buildings[i] &&
          this.buildings[i].buildingName &&
          this.buildings[i].buildingName.BuildingName
        )
      ) {
        this.buildingControl[i].setErrors({ invalidContact: true });
      } else {
        this.buildingControl[i].setErrors(null);
      }
    }

    this.showErrorsDisclaimer = form.invalid || this.reviewDisabled();

    //A Hardware Only form must have at least one row in the materials section that is a CAP row.
    this.showMaterialHardwareOnlyErrorDisclaimer =
      (!this.materialsHasEntry() || !this.materialHasCapital()) &&
      this.hardwareOrSoftware === 'Hardware Only';
    //A Hardware and Software form must have at least one row in the materials section that is a Hardware CAP row.
    //A Hardware and Software form must have at least one row in either the materials or labor section that is a Software CAP row.
    this.showMaterialHardwareSoftwareErrorDisclaimer =
      (!this.materialHasCapitalHardware() ||
        (!this.materialHasCapitalSoftware() && !this.laborHasCapitalSoftware())) &&
      this.hardwareOrSoftware === 'Hardware and Software';
    //A Software Only form must have at least one row in the materials or labor section that is a CAP row.
    this.showMaterialSoftwareOnlyErrorDisclaimer =
      !this.materialHasCapital() &&
      !this.laborHasCapitalSoftware() &&
      this.hardwareOrSoftware === 'Software Only';
    //An O&M form must have at least one row with all fields filled out in either the Materials or Labor section.
    this.showMaterialOmOnlyErrorDisclaimer =
      !this.employeeContractorHasEntry() &&
      !this.materialsHasEntry() &&
      this.hardwareOrSoftware === 'O&M Only';

    if (
      this.showErrorsDisclaimer ||
      this.showMaterialHardwareOnlyErrorDisclaimer ||
      this.showMaterialHardwareSoftwareErrorDisclaimer ||
      this.showMaterialSoftwareOnlyErrorDisclaimer ||
      this.showMaterialOmOnlyErrorDisclaimer
    ) {
      this.scrollToErrorDisclaimer();
      return;
    }

    this.saveProjectData();
    this.router.navigate(['/it-project-review']);
  }

  scrollToErrorDisclaimer() {
    setTimeout(() => {
      const errorDisclaimerEl = document.getElementById('errorDisclaimerID');
      const materialHardwareErrorDisclaimerEl = document.getElementById(
        'materialHardwareErrorDisclaimerID'
      );
      const materialSoftwareErrorDisclaimerEl = document.getElementById(
        'materialSoftwareErrorDisclaimerID'
      );
      const materialOmOnlyErrorDisclaimerEl = document.getElementById(
        'materialOmOnlyErrorDisclaimerID'
      );

      if (errorDisclaimerEl) {
        errorDisclaimerEl.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      } else if (materialHardwareErrorDisclaimerEl) {
        materialHardwareErrorDisclaimerEl.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      } else if (materialSoftwareErrorDisclaimerEl) {
        materialSoftwareErrorDisclaimerEl.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      } else if (materialOmOnlyErrorDisclaimerEl) {
        materialOmOnlyErrorDisclaimerEl.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    });
  }

  displayFnBuildingInfo(value: any): string | undefined {
    if (!value) {
      return '';
    } else {
      return value.BuildingName;
    }
  }

  expandedBuildingInfoFilter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.expandedBuildingInfoOptions.filter((option) => {
        if (option.BuildingName) {
          return option.BuildingName.toLowerCase().includes(filter.toLowerCase());
        } else {
          return this.expandedBuildingInfoOptions;
        }
      });
    } else {
      return this.expandedBuildingInfoOptions;
    }
  }

  buildingInfoFilter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.buildingInfoOptions.filter((option) => {
        return option.BuildingName.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return this.buildingInfoOptions;
    }
  }

  operatingUnitFilter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.operatingUnitOptions.filter((option) => {
        if (this.hardwareOrSoftware === 'O&M Only') {
          return option.OPERATING_UNIT.concat(' - ')
            .concat(option.DESCR)
            .toLowerCase()
            .includes(filter.toLowerCase());
        } else {
          return (
            option.OPERATING_UNIT.concat(' - ')
              .concat(option.DESCR)
              .toLowerCase()
              .includes(filter.toLowerCase()) &&
            option.BUSINESS_UNIT !== '50124' &&
            option.BUSINESS_UNIT !== '50224' &&
            option.BUSINESS_UNIT !== '75083'
          );
        }
      });
    } else {
      return this.operatingUnitOptions;
    }
  }

  departmentFilter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.defaultsByDepartment.filter((option) => {
        return option.department.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return this.defaultsByDepartment;
    }
  }

  allocationDefaultFilter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.allocationDefaults.filter((option) => {
        return option.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return this.allocationDefaults;
    }
  }

  distributeCostFilter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.distributeOptions.filter((option) => {
        return option.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return this.distributeOptions;
    }
  }

  fundingProjectFilter(filter: string, allocation: Allocation): any[] {
    this.lastFilter = filter;
    if (filter) {
      return allocation.fundingProjectOptions.filter((option) => {
        return option.work_order_number.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return allocation.fundingProjectOptions;
    }
  }

  stateFilter(filter: string, allocation: Allocation): any[] {
    this.lastFilter = filter;
    if (filter) {
      return allocation.stateOptions.filter((option) => {
        return option.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return allocation.stateOptions;
    }
  }

  costFilter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.costOptions.filter((option) => {
        return option.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return this.costOptions;
    }
  }

  unitOfPropertyDescriptionFilter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.uopOptions.filter((option) => {
        return option.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return this.uopOptions;
    }
  }

  workTaskFilter(filter: string): string[] {
    this.lastFilter = filter;
    if (filter) {
      return this.workTaskOptions.filter((option) => {
        return option.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return this.workTaskOptions;
    }
  }

  chargeTypeFilter(filter: string): string[] {
    this.lastFilter = filter;
    if (filter) {
      return this.chargeTypeOptions.filter((option) => {
        return option.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return this.chargeTypeOptions;
    }
  }

  contingencyCostFilter(filter: string): string[] {
    this.lastFilter = filter;
    if (filter) {
      return this.contingencyCostOptions.filter((option) => {
        return option.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return this.contingencyCostOptions;
    }
  }

  workDescriptionFilter(filter: string, index: number): string[] {
    this.lastFilter = filter;
    if (filter) {
      return this.workDescriptions[index].filter((option) => {
        if (option.WORK_TASK) {
          return option.WORK_TASK.toLowerCase().includes(filter.toLowerCase());
        } else {
          return this.workDescriptions[index];
        }
      });
    } else {
      return this.workDescriptions[index];
    }
  }

  loadExtraBuildingOptions() {
    this.http.get('assets/extra-buildings.json').subscribe(
      (result) => {
        this.extraBuildings = result as string[];
        if (this.hardwareOrSoftware !== 'O&M Only') {
          this.extraBuildings.splice(1, 1);
        }
        let buildingArray = [];
        for (let i = 0; i < this.extraBuildings.length; i++) {
          buildingArray.push({
            BuildingName: this.extraBuildings[i],
          });
        }
        this.expandedBuildingInfoOptions = buildingArray.concat(this.buildingInfoOptions);
        this.buildingInfoOptions = _.sortBy(this.buildingInfoOptions, ['BuildingName']);
        this.expandedBuildingInfoOptions = _.sortBy(this.expandedBuildingInfoOptions, [
          'BuildingName',
        ]);
        this.filteredBuildingInfoOptions = this.buildingInfoControl.valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) => this.expandedBuildingInfoFilter(filter))
        );
        this.filteredBuildingOptions[0] = this.buildingControl[0].valueChanges.pipe(
          startWith<string | any[]>(''),
          map((value) => (typeof value === 'string' ? value : this.lastFilter)),
          map((filter) => this.buildingInfoFilter(filter))
        );
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Extra Building Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Extra Building Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  costChanged(value: any, i: number, j: number) {
    if (value === 'O&M') {
      this.buildings[i].materialEstimates[j].unitOfPropertyDescription = null;
    }
  }

  recalculateTotalCost(i: number, j: number) {
    const unitCosts = Number(this.buildings[i].materialEstimates[j].unitCosts || 0);
    const quantity = Number(this.buildings[i].materialEstimates[j].quantity || 0);
    this.buildings[i].materialEstimates[j].totalCosts = quantity * unitCosts;
  }

  openCapabilityDialog(i: number, j: number) {
    this.dialog.open(CapabilityDescriptionComponent, {
      data: {
        capabilityDetails: this.releaseDetails[i].capabilityDetails[j],
        readOnly: false,
      },
      disableClose: true,
    });
  }

  onFileSelected(event) {
    if (this.itSparGuid) {
      for (let i = 0; i < event.target.files.length; i++) {
        this.uploadFile(event.target.files[i]);
      }
    } else {
      this.generateGUID(event.target.files);
    }
  }

  onDrop(event: any) {
    if (this.itSparGuid) {
      event.preventDefault();
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        this.uploadFile(event.dataTransfer.files[i]);
      }
    } else {
      event.preventDefault();
      this.generateGUID(event.dataTransfer.files);
    }
  }

  uploadFile(file: File) {
    let userData = JSON.parse(sessionStorage.getItem('userInfo'));
    let stringArray = userData.account.name.split(',');
    let lastName = stringArray[0];
    let firstName = stringArray[1].substring(1);
    let today = new Date();
    let yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();
    let ddstring = '';
    let mmstring = '';
    if (dd < 10) {
      ddstring = '0' + dd;
    } else {
      ddstring = dd.toString();
    }
    if (mm < 10) {
      mmstring = '0' + mm;
    } else {
      mmstring = mm.toString();
    }
    let formattedToday = mmstring + '/' + ddstring + '/' + yyyy;
    let data = {
      fileName: this.itSparGuid.concat('/').concat(file.name),
      contentType: file.type,
      method: 'put_object',
    };
    this.dataService.getPresignedURL(data).subscribe(
      (result) => {
        let presignedURL = JSON.parse(result as string).presigned_url;
        this.httpNoInterceptors
          .put(presignedURL, file, { headers: { 'Content-Type': file.type } })
          .subscribe(
            (result) => {
              let reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => {
                this.files.push(new UploadFile(firstName + ' ' + lastName, formattedToday));
                this.files[this.files.length - 1].fileName = file.name;
                this.files[this.files.length - 1].contentType = file.type;
                if (this.draftSaved) {
                  this.saveItSparData();
                }
              };
            },
            (error) => {
              console.log('error', error);
              let errorType = '';
              let errorDescription = '';
              if (error.status === 0) {
                errorType = 'Upload Blocked';
                errorDescription =
                  'File upload was blocked. Your network security policy may not allow this file type to be uploaded. Please try uploading a PDF instead.';
              } else {
                if (error.error.message) {
                  errorDescription = errorDescription.concat(
                    'Upload File to Presigned URL Error - ',
                    error.error.message
                  );
                } else {
                  errorDescription = errorDescription.concat('Upload File to Presigned URL Error');
                }
                errorType = errorType.concat(error.status, ' ', error.statusText);
              }

              let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
              };
              this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
              });
            }
          );
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Presigned URL Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Presigned URL Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  downloadFile(index: number) {
    let data = {
      fileName: this.itSparGuid.concat('/').concat(this.files[index].fileName),
      contentType: this.files[index].contentType,
      method: 'get_object',
    };
    this.dataService.getPresignedURL(data).subscribe(
      (result) => {
        let presignedUrl = JSON.parse(result as string).presigned_url;
        this.http
          .get(presignedUrl, {
            responseType: 'blob',
          })
          .subscribe((result) => {
            let fileURL = URL.createObjectURL(result);
            let downloadLink = document.createElement('a');
            downloadLink.href = fileURL;
            downloadLink.download = this.files[index].fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          });
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Presigned URL Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Presigned URL Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
    if (this.draftSaved) {
      this.saveItSparData();
    }
  }

  workTaskChanged(workTask: any, index: number) {
    this.workDescriptions[index] = workTask.workDescriptions;
    this.filteredWorkDescriptionOptions[index] = this.workDescriptionControl[
      index
    ].valueChanges.pipe(
      startWith<string | any[]>(''),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.workDescriptionFilter(filter, index))
    );
    this.laborDetails[index].workDescription = '';
  }

  saveProjectData() {
    if (this.department) {
      sessionStorage.setItem('department', JSON.stringify(this.department));
    }
    if (this.buildingInfo) {
      sessionStorage.setItem('buildingInfo', JSON.stringify(this.buildingInfo));
    }
    if (this.distributeCost) {
      sessionStorage.setItem('distributeCost', JSON.stringify(this.distributeCost));
    }
    if (this.defaultOption) {
      sessionStorage.setItem('defaultOption', JSON.stringify(this.defaultOption));
    }
    if (this.defaultOptionChoices) {
      sessionStorage.setItem('defaultOptionChoices', JSON.stringify(this.defaultOptionChoices));
    }
    if (this.releaseDetails) {
      sessionStorage.setItem('releaseDetails', JSON.stringify(this.releaseDetails));
    }
    if (this.todayDate) {
      sessionStorage.setItem('todayDate', JSON.stringify(this.todayDate));
    }
    if (this.allocations) {
      sessionStorage.setItem('allocations', JSON.stringify(this.allocations));
    }
    if (this.buildings) {
      sessionStorage.setItem('buildings', JSON.stringify(this.buildings));
    }
    if (this.descriptionOptions) {
      sessionStorage.setItem('descriptionOptions', JSON.stringify(this.descriptionOptions));
    }
    if (this.laborDetails) {
      sessionStorage.setItem('laborDetails', JSON.stringify(this.laborDetails));
    }
    if (this.contingencyDetails) {
      sessionStorage.setItem('contingencyDetails', JSON.stringify(this.contingencyDetails));
    }
    if (this.operatingUnit) {
      sessionStorage.setItem('operatingUnit', JSON.stringify(this.operatingUnit));
    }
    if (this.businessUnit) {
      sessionStorage.setItem('businessUnit', JSON.stringify(this.businessUnit));
    }
    if (this.businessUnitDescription) {
      sessionStorage.setItem(
        'businessUnitDescription',
        JSON.stringify(this.businessUnitDescription)
      );
    }
    if (this.combinedBusinessUnit) {
      sessionStorage.setItem('combinedBusinessUnit', JSON.stringify(this.combinedBusinessUnit));
    }
    if (this.uopDescriptionOptions) {
      sessionStorage.setItem('uopDescriptionOptions', JSON.stringify(this.uopDescriptionOptions));
    }
    if (this.firstBuildingTouched) {
      sessionStorage.setItem('firstBuildingTouched', JSON.stringify(this.firstBuildingTouched));
    }
    if (this.isLighthouseProject) {
      sessionStorage.setItem('isLighthouseProject', JSON.stringify(this.isLighthouseProject));
    }
    if (this.additionalComments) {
      sessionStorage.setItem('additionalComments', JSON.stringify(this.additionalComments));
    }
    if (this.additionalApprovers) {
      sessionStorage.setItem('additionalApprovers', JSON.stringify(this.additionalApprovers));
    }
    if (this.approverList) {
      sessionStorage.setItem('approverList', JSON.stringify(this.approverList));
    }
    if (this.xmlDoc) {
      sessionStorage.setItem('xmlDoc', JSON.stringify(this.xmlDoc));
    }
    if (this.parser) {
      sessionStorage.setItem('parser', JSON.stringify(this.parser));
    }
    if (this.doaAmounts) {
      sessionStorage.setItem('doaAmounts', JSON.stringify(this.doaAmounts));
    }
    if (this.additionalApproverOptions) {
      sessionStorage.setItem(
        'additionalApproverOptions',
        JSON.stringify(this.additionalApproverOptions)
      );
    }
    if (this.primaryContact) {
      sessionStorage.setItem('primaryContact', JSON.stringify(this.primaryContact));
    }
    if (this.itSponsor) {
      sessionStorage.setItem('itSponsor', JSON.stringify(this.itSponsor));
    }
    if (this.lastFilter) {
      sessionStorage.setItem('lastFilter', JSON.stringify(this.lastFilter));
    }
    if (this.extraBuildings) {
      sessionStorage.setItem('extraBuildings', JSON.stringify(this.extraBuildings));
    }
    if (this.filteredBuildingOptions) {
      sessionStorage.setItem(
        'filteredBuildingOptions',
        JSON.stringify(this.filteredBuildingOptions)
      );
    }
    if (this.files) {
      sessionStorage.setItem('files', JSON.stringify(this.files));
    }
    if (this.workDescriptions) {
      sessionStorage.setItem('workDescriptions', JSON.stringify(this.workDescriptions));
    }
    if (this.hardwareOrSoftware) {
      sessionStorage.setItem('previousHardwareOrSoftware', this.hardwareOrSoftware);
    }
    sessionStorage.setItem('allocationsTouched', this.allocationsTouched.toString());
    if (this.draftSaved) {
      sessionStorage.setItem('draftSaved', this.draftSaved);
    }
    if (this.draftSavedDay) {
      sessionStorage.setItem('draftSavedDay', this.draftSavedDay);
    }
    if (this.draftSavedTime) {
      sessionStorage.setItem('draftSavedTime', this.draftSavedTime);
    }
    if (this.etsPacAssignment) {
      sessionStorage.setItem('etsPacAssignment', JSON.stringify(this.etsPacAssignment));
    }
  }

  setAllocationsAsTouched() {
    this.allocationsTouched = true;
  }

  tangiblePropertyCheck(estimate: MaterialEstimate) {
    if (
      estimate.cost === 'CAP' &&
      (estimate.unitOfPropertyDescription === 'Communication Equipment' ||
        estimate.unitOfPropertyDescription === 'Electronic Data Processing' ||
        estimate.unitOfPropertyDescription === 'Miscellaneous Equipment' ||
        estimate.unitOfPropertyDescription === 'Office Furniture and Equipment' ||
        estimate.unitOfPropertyDescription === 'Structures and Improvements' ||
        estimate.unitOfPropertyDescription === 'Tools, Shop & Garage Equipment') &&
      Number(estimate.unitCosts) < 500 &&
      estimate.unitCosts !== null
    ) {
      return true;
    } else {
      return false;
    }
  }

  tangibleTotalCostCheck(estimate: MaterialEstimate) {
    if (
      estimate.cost === 'CAP' &&
      (estimate.unitOfPropertyDescription === 'Communication Equipment' ||
        estimate.unitOfPropertyDescription === 'Electronic Data Processing' ||
        estimate.unitOfPropertyDescription === 'Miscellaneous Equipment' ||
        estimate.unitOfPropertyDescription === 'Office Furniture and Equipment' ||
        estimate.unitOfPropertyDescription === 'Structures and Improvements' ||
        estimate.unitOfPropertyDescription === 'Tools, Shop & Garage Equipment') &&
      Number(estimate.unitCosts) >= 500 &&
      Number(estimate.unitCosts) <= 999 &&
      estimate.unitCosts !== null &&
      estimate.totalCosts < 50000
    ) {
      return true;
    } else {
      return false;
    }
  }

  tangibleDateCheck(estimate: MaterialEstimate) {
    if (
      estimate.cost === 'CAP' &&
      (estimate.unitOfPropertyDescription === 'Communication Equipment' ||
        estimate.unitOfPropertyDescription === 'Electronic Data Processing' ||
        estimate.unitOfPropertyDescription === 'Miscellaneous Equipment' ||
        estimate.unitOfPropertyDescription === 'Office Furniture and Equipment' ||
        estimate.unitOfPropertyDescription === 'Structures and Improvements' ||
        estimate.unitOfPropertyDescription === 'Tools, Shop & Garage Equipment') &&
      Number(estimate.unitCosts) >= 500 &&
      Number(estimate.unitCosts) <= 999 &&
      estimate.unitCosts !== null &&
      !this.workLessThanYear()
    ) {
      return true;
    } else {
      return false;
    }
  }

  workLessThanYear() {
    return this.estimatedInServiceDate.getTime() - this.estimatedStartDate.getTime() <= 31556952000;
  }

  additionalCommentLength() {
    if (this.additionalComments) {
      return this.additionalComments.length;
    } else {
      return 0;
    }
  }

  distributeCostChosen() {
    for (let i = 0; i < this.distributeOptions.length; i++) {
      if (this.distributeCost === this.distributeOptions[i]) {
        return true;
      }
    }
    return false;
  }

  defaultOptionChosen() {
    for (let i = 0; i < this.allocationDefaults.length; i++) {
      if (this.defaultOption === this.allocationDefaults[i]) {
        return true;
      }
    }
    return false;
  }

  stateChosen(index: number) {
    for (let i = 0; i < this.allocations[index].stateOptions.length; i++) {
      if (this.allocations[index].state === this.allocations[index].stateOptions[i]) {
        return true;
      }
    }
    return false;
  }

  costChosen(index: number, jindex: number) {
    for (let i = 0; i < this.costOptions.length; i++) {
      if (this.buildings[index].materialEstimates[jindex].cost === this.costOptions[i]) {
        return true;
      }
    }
    return false;
  }

  unitOfPropertyDescriptionChosen(index: number, jindex: number) {
    for (let i = 0; i < this.uopOptions.length; i++) {
      if (
        this.buildings[index].materialEstimates[jindex].unitOfPropertyDescription ===
        this.uopOptions[i]
      ) {
        return true;
      }
    }
    return false;
  }

  workTaskChosen(index: number) {
    for (let i = 0; i < this.workTaskOptions.length; i++) {
      if (this.laborDetails[index].workTask === this.workTaskOptions[i]) {
        return true;
      }
    }
    return false;
  }

  workDescriptionChosen(index: number) {
    for (let i = 0; i < this.workDescriptions[index].length; i++) {
      if (this.laborDetails[index].workDescription === this.workDescriptions[index][i]) {
        return true;
      }
    }
    return false;
  }

  chargeTypeChosen(index: number) {
    for (let i = 0; i < this.chargeTypeOptions.length; i++) {
      if (this.laborDetails[index].chargeType === this.chargeTypeOptions[i]) {
        return true;
      }
    }
    return false;
  }

  contingencyCostChosen(index: number) {
    for (let i = 0; i < this.contingencyCostOptions.length; i++) {
      if (this.contingencyDetails[index].cost === this.contingencyCostOptions[i]) {
        return true;
      }
    }
    return false;
  }

  deleteDepartment() {
    this.department = '' as any;
  }

  deleteBuildingInfo() {
    this.buildingInfo = '' as any;
  }

  deleteDistributeCost() {
    this.distributeCost = '' as any;
    this.distributeCostChange('');
  }

  deleteDefaultOption() {
    this.defaultOption = '' as any;
  }

  deleteOperatingUnit(index: number) {
    this.allocations[index].operatingUnit = '' as any;
  }

  deleteFundingProjectID(index: number) {
    this.allocations[index].fundingProjectID = '' as any;
    this.updateMatchingBusinessUnits(index);
  }

  deleteState(index: number) {
    this.allocations[index].state = '' as any;
  }

  deleteBuildingName(index: number) {
    this.buildings[index].buildingName = '' as any;
  }

  deleteCost(i: number, j: number) {
    this.buildings[i].materialEstimates[j].cost = '' as any;
  }

  deleteUnitOfPropertyDescription(i: number, j: number) {
    this.buildings[i].materialEstimates[j].unitOfPropertyDescription = '' as any;
  }

  deleteWorkTask(i: number) {
    this.laborDetails[i].workTask = '' as any;
  }

  deleteWorkDescription(i: number) {
    this.laborDetails[i].workDescription = '' as any;
  }

  deleteChargeType(i: number) {
    this.laborDetails[i].chargeType = '' as any;
  }

  deleteContingencyCost(i: number) {
    this.contingencyDetails[i].cost = '' as any;
  }

  deleteAdditionalApproverValue(i: number) {
    this.additionalApprovers[i] = '' as any;
  }

  clearDefaultOption() {
    if (!(this.department && this.department.department)) {
      this.defaultOption = '' as any;
    }
  }

  multipleNuclearHardwareSoftware() {
    if (this.hardwareOrSoftware === 'Hardware and Software') {
      return this.containsMultipleNuclear();
    }
    return false;
  }

  duplicateAllocation() {
    for (let i = 0; i < this.allocations.length; i++) {
      for (let j = i + 1; j < this.allocations.length; j++) {
        if (
          this.allocations[i].operatingUnit &&
          this.allocations[j].operatingUnit &&
          this.allocations[i].operatingUnit.OPERATING_UNIT ===
            this.allocations[j].operatingUnit.OPERATING_UNIT
        ) {
          return true;
        }
      }
    }
    return false;
  }

  emptyAllocationLine() {
    for (let i = 0; i < this.allocations.length; i++) {
      if (this.allocations[i].percentage === 0) {
        return true;
      }
    }
    return false;
  }

  sameNuclearSite() {
    if (!this.nuclearAbbreviations) {
      return false;
    }
    for (let i = 0; i < this.allocations.length; i++) {
      for (let j = i + 1; j < this.allocations.length; j++) {
        if (
          (this.allocations[i].businessUnitValue === '20048' ||
            this.allocations[i].businessUnitValue === '50125') &&
          (this.allocations[j].businessUnitValue === '20048' ||
            this.allocations[j].businessUnitValue === '50125')
        ) {
          let firstElementMatchFound = false;
          let secondElementMatchFound = false;
          let firstElementAbbreviation = '';
          let secondElementAbbreviation = '';
          for (
            let k = 0;
            k < this.nuclearAbbreviations.length &&
            (!firstElementMatchFound || !secondElementMatchFound);
            k++
          ) {
            if (
              this.allocations[i].operatingUnit.OPERATING_UNIT ===
              this.nuclearAbbreviations[k].operatingUnit
            ) {
              firstElementAbbreviation = this.nuclearAbbreviations[k].stationCode;
              firstElementMatchFound = true;
            }
            if (
              this.allocations[j].operatingUnit.OPERATING_UNIT ===
              this.nuclearAbbreviations[k].operatingUnit
            ) {
              secondElementAbbreviation = this.nuclearAbbreviations[k].stationCode;
              secondElementMatchFound = true;
            }
          }
          if (firstElementMatchFound && secondElementMatchFound) {
            if (
              firstElementAbbreviation === secondElementAbbreviation &&
              this.allocations[i].operatingUnit.OPERATING_UNIT !==
                this.allocations[j].operatingUnit.OPERATING_UNIT
            ) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  sameOperatingUnit() {
    for (let i = 0; i < this.allocations.length; i++) {
      for (let j = i + 1; j < this.allocations.length; j++) {
        if (
          this.allocations[i].businessUnitValue !== '20048' &&
          this.allocations[i].businessUnitValue !== '50125' &&
          this.allocations[j].businessUnitValue !== '20048' &&
          this.allocations[j].businessUnitValue !== '50125'
        ) {
          if (this.allocations[i].businessUnitValue === this.allocations[j].businessUnitValue) {
            return true;
          }
        }
      }
    }
    return false;
  }

  containsMultipleNuclear() {
    let nuclearFound = 0;
    for (let i = 0; i < this.allocations.length && nuclearFound < 2; i++) {
      if (
        (this.allocations[i].businessUnitValue === '20048' ||
          this.allocations[i].businessUnitValue === '50125') &&
        this.nuclearAbbreviations
      ) {
        let matchFound = false;
        for (let j = 0; j < this.nuclearAbbreviations.length && !matchFound; j++) {
          if (
            this.allocations[i].operatingUnit.OPERATING_UNIT ===
            this.nuclearAbbreviations[j].operatingUnit
          ) {
            matchFound = true;
            nuclearFound++;
          }
        }
      }
    }
    return nuclearFound === 2;
  }

  loadNuclearAbbreviations() {
    this.http.get('assets/nuclear-abbreviations.json').subscribe(
      (result) => {
        this.nuclearAbbreviations = result as any[];
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Nuclear Abbreviations Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Nuclear Abbreviations Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  clearSessionStorage() {
    let userData = JSON.parse(sessionStorage.getItem('userInfo'));
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    let fullTokenPayload = JSON.parse(sessionStorage.getItem('fullTokenPayload'));
    sessionStorage.clear();
    sessionStorage.setItem('userInfo', JSON.stringify(userData));
    sessionStorage.setItem('currentUser', JSON.stringify(currentUser));
    sessionStorage.setItem('fullTokenPayload', JSON.stringify(fullTokenPayload));
  }

  saveDraft() {
    if (this.itSparGuid) {
      this.saveItSparData();
    } else {
      this.generateGUID();
    }
  }

  generateGUID(files?: any) {
    this.dataService.getSparGuid().subscribe(
      (result: any) => {
        this.itSparGuid = result.body.itspar_guid;
        sessionStorage.setItem('itSparGuid', JSON.stringify(this.itSparGuid));
        if (!files) {
          this.saveItSparData();
        } else {
          // Persist the new GUID to DynamoDB before uploading. Uploading
          // immediately after generating the GUID (but before it's saved)
          // leaves the GUID living only in sessionStorage - if that's lost
          // before an explicit save, a later save mints a new GUID and
          // orphans the earlier S3 upload (2026-07-01 prod incident, form #400192000).
          this.saveItSparData(false, () => {
            for (let i = 0; i < files.length; i++) {
              this.uploadFile(files[i]);
            }
          });
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Generate IT SPAR GUID Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Generate IT SPAR GUID Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  saveItSparData(deleteDraft = false, onSuccess?: () => void) {
    let releaseDetailsObject = [];
    for (let i = 0; i < this.releaseDetails.length; i++) {
      releaseDetailsObject.push({
        capabilityDetails: [],
      });
      for (let j = 0; j < this.releaseDetails[i].capabilityDetails.length; j++) {
        releaseDetailsObject[i].capabilityDetails.push({
          releaseNumber: this.releaseDetails[i].capabilityDetails[j].releaseNumber,
          releaseDate: this.releaseDetails[i].capabilityDetails[j].releaseDate,
          capability: this.releaseDetails[i].capabilityDetails[j].capabilities,
          description: this.releaseDetails[i].capabilityDetails[j].description,
          capitalCost: this.releaseDetails[i].capabilityDetails[j].capitalCost,
          omCost: this.releaseDetails[i].capabilityDetails[j].omCost,
        });
      }
    }
    let allocationsObject = [];
    for (let i = 0; i < this.allocations.length; i++) {
      allocationsObject.push({
        operatingUnit: JSON.stringify(this.allocations[i].operatingUnit),
        businessUnit: this.allocations[i].businessUnit,
        fundingProjectId: JSON.stringify(this.allocations[i].fundingProjectID),
        function: this.allocations[i].function,
        state: this.allocations[i].state,
        percentage: `${this.allocations[i].percentage}`,
      });
    }
    let buildingsObject = [];
    for (let i = 0; i < this.buildings.length; i++) {
      buildingsObject.push({
        building: JSON.stringify(this.buildings[i].buildingName),
        materialEstimates: [],
      });
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        buildingsObject[i].materialEstimates.push({
          cost: this.buildings[i].materialEstimates[j].cost,
          details: this.buildings[i].materialEstimates[j].unitOfPropertyDetails,
          uopDescription: this.buildings[i].materialEstimates[j].unitOfPropertyDescription,
          quantity: this.buildings[i].materialEstimates[j].quantity,
          unitCosts: this.buildings[i].materialEstimates[j].unitCosts,
          totalCosts: this.buildings[i].materialEstimates[j].totalCosts,
        });
      }
    }
    let laborDetailsObject = [];
    for (let i = 0; i < this.laborDetails.length; i++) {
      laborDetailsObject.push({
        workTask: JSON.stringify(this.laborDetails[i].workTask),
        workDescription: this.laborDetails[i].workDescription,
        chargeType: this.laborDetails[i].chargeType,
        totalCosts: this.laborDetails[i].totalCosts,
      });
    }
    let contingencyDetailsObject = [];
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      contingencyDetailsObject.push({
        cost: this.contingencyDetails[i].cost,
        description: this.contingencyDetails[i].description,
        totalCosts: this.contingencyDetails[i].totalCosts,
      });
    }
    let filesObject = [];
    for (let i = 0; i < this.files.length; i++) {
      filesObject.push(JSON.stringify(this.files[i]));
    }
    let additionalApproverObject = [];
    for (let i = 0; i < this.additionalApprovers.length; i++) {
      additionalApproverObject.push({
        displayName: this.additionalApprovers[i].displayName,
        givenName: this.additionalApprovers[i].givenName,
        surname: this.additionalApprovers[i].surname,
        mail: this.additionalApprovers[i].mail,
        mailNickname: this.additionalApprovers[i].mailNickname,
        jobTitle: this.additionalApprovers[i].jobTitle,
        doaAmount: this.doaAmounts[i + 1],
      });
    }
    additionalApproverObject = _.orderBy(additionalApproverObject, [
      'doaAmount',
      'surname',
      'givenName',
      'displayName',
    ]);
    let etsPacAssignmentValue = {
      displayName: '',
      givenName: '',
      surname: '',
      mail: '',
      mailNickname: '',
      jobTitle: '',
      doaAmount: '',
    };
    if (this.etsPacAssignment) {
      etsPacAssignmentValue = {
        displayName: this.etsPacAssignment.displayName,
        givenName: this.etsPacAssignment.givenName,
        surname: this.etsPacAssignment.surname,
        mail: this.etsPacAssignment.mail,
        mailNickname: this.etsPacAssignment.mailNickname,
        jobTitle: this.etsPacAssignment.jobTitle,
        doaAmount: this.etsPacAssignment.doaAmount,
      };
    }
    let callBody = {
      itSparGuid: this.itSparGuid,
      patiId: JSON.stringify(this.patiProject),
      shortDescription: this.projectName,
      etsProjectClassification: JSON.stringify(this.itProjectClassification),
      estimatedStartDate: this.convertToDateStringFormat(this.estimatedStartDate),
      estimatedInServiceDate: this.convertToDateStringFormat(this.estimatedInServiceDate),
      overviewAndScope: this.projectScopeDescription,
      primaryContact: {
        displayName: this.primaryContact ? this.primaryContact.displayName : null,
        givenName: this.primaryContact ? this.primaryContact.givenName : null,
        surname: this.primaryContact ? this.primaryContact.surname : null,
        mail: this.primaryContact ? this.primaryContact.mail : null,
        mailNickname: this.primaryContact ? this.primaryContact.mailNickname : null,
        jobTitle: this.primaryContact ? this.primaryContact.jobTitle : null,
      },
      itSponsor: {
        displayName: this.itSponsor ? this.itSponsor.displayName : null,
        givenName: this.itSponsor ? this.itSponsor.givenName : null,
        surname: this.itSponsor ? this.itSponsor.surname : null,
        mail: this.itSponsor ? this.itSponsor.mail : null,
        mailNickname: this.itSponsor ? this.itSponsor.mailNickname : null,
        jobTitle: this.itSponsor ? this.itSponsor.jobTitle : null,
        doaAmount: this.doaAmounts && this.doaAmounts.length > 0 ? this.doaAmounts[0] : null,
      },
      omOnly: this.omOnly,
      relatedWork: this.relatedWork,
      hardwareOrSoftware: this.hardwareOrSoftware,
      purchasingWarranties: this.purchasingWarranties,
      projectConsistsOf: this.projectConsistsOf,
      expectedLife: this.expectedLife,
      agileEffort: this.agileEffort,
      softwareBeingUsed: this.softwareBeingUsed,
      vendorName: this.vendorName,
      softwareName: this.softwareName,
      inServiceYear: this.inServiceYear,
      softwareProjectOverview: this.softwareProjectOverview,
      dataConversionActivities: this.dataConversionActivities,
      trainingCosts: this.trainingCosts,
      associatedRetirement: this.associatedRetirement,
      softwareToBeRetired: this.softwareToBeRetired,
      retiredInServiceDate: this.retiredInServiceDate,
      maintenanceContracts: this.maintenanceContracts,
      replacingInterfaces: this.replacingInterfaces,
      howSoftwareReleased: this.howSoftwareReleased,
      perpetualLicenses: this.perpetualLicenses,
      contractualRight: this.contractualRight,
      significantPenalty: this.significantPenalty,
      isFeasible: this.isFeasible,
      serviceFees: this.serviceFees,
      useWithoutPaying: this.useWithoutPaying,
      department: JSON.stringify(this.department),
      buildingInfo: JSON.stringify(this.buildingInfo),
      releaseDetails: releaseDetailsObject,
      distributeCost: JSON.stringify(this.distributeCost),
      defaultOption: JSON.stringify(this.defaultOption),
      allocations: allocationsObject,
      buildings: buildingsObject,
      laborDetails: laborDetailsObject,
      contingencyDetails: contingencyDetailsObject,
      additionalComments: this.additionalComments,
      attachments: filesObject,
      approvers: additionalApproverObject,
      formStatus: deleteDraft ? 'Canceled' : 'Draft',
      formActivity: [],
      currentApprover: {
        displayName: '',
        givenName: '',
        surname: '',
        mail: '',
        mailNickname: '',
        jobTitle: '',
        doaAmount: '',
      },
      formOwner: {
        displayName: '',
        givenName: this.firstName,
        surname: this.lastName,
        mail: this.userEmail,
        mailNickname: '',
        jobTitle: '',
        doaAmount: '',
      },
      etsPacAssignment: etsPacAssignmentValue,
      currentAssignment: {
        displayName: '',
        givenName: '',
        surname: '',
        mail: '',
        mailNickname: '',
        jobTitle: '',
        doaAmount: '',
      },
      tables: '',
      effectiveDate: '',
      formNumber: this.formNumber,
      displayRevisionNumber: this.displayRevisionNumber,
      previousCapitalSubtotal: this.previousCapitalSubtotal.toString(),
      previousOMSubtotal: this.previousOMSubtotal.toString(),
      revisionExists: 'false',
    };
    this.dataService.saveItSparData(callBody).subscribe(
      (result) => {
        if (result.statusCode !== 200) {
          console.log('error', result);
          let errorType = '';
          let errorDescription = result;
          let dataStructure = {
            errorType: errorType,
            errorDescription: errorDescription,
          };
          this.dialog.open(ErrorDialogComponent, {
            data: dataStructure,
            disableClose: true,
          });
        } else {
          if (deleteDraft) {
            this.clearSessionStorage();
            this.router.navigate(['/dashboard']);
            return;
          }
          this.formOwner = callBody.formOwner;
          this.draftSaved = 'Saved';
          this.draftSavedDate = new Date();
          this.draftSavedDay =
            (this.draftSavedDate.getMonth() > 8
              ? this.draftSavedDate.getMonth() + 1
              : '0' + (this.draftSavedDate.getMonth() + 1)) +
            '/' +
            (this.draftSavedDate.getDate() > 9
              ? this.draftSavedDate.getDate()
              : '0' + this.draftSavedDate.getDate()) +
            '/' +
            this.draftSavedDate.getFullYear();
          this.draftSavedTime = this.formatAMPM(this.draftSavedDate);
          sessionStorage.setItem('draftSaved', this.draftSaved);
          sessionStorage.setItem('draftSavedDay', this.draftSavedDay);
          sessionStorage.setItem('draftSavedTime', this.draftSavedTime);
          if (onSuccess) {
            onSuccess();
          }
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Save IT SPAR Data Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Save IT SPAR Data Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  convertToDateStringFormat(date: Date): string {
    return (
      date.getFullYear().toString() +
      '-' +
      (date.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      date.getDate().toString().padStart(2, '0')
    );
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  compareDepartment(o1: any, o2: any): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return o1.department === o2.department;
  }

  compareWorkTask(o1: any, o2: any): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return o1.workTask === o2.workTask;
  }

  updateMatchingBusinessUnits(index: number) {
    let firstMatchIndex = -1;
    for (let i = 0; i < this.allocations.length; i++) {
      if (
        (this.allocations[index].businessUnitValue === this.allocations[i].businessUnitValue &&
          this.allocations[index].businessUnitValue !== '20048' &&
          this.allocations[index].businessUnitValue !== '50125') ||
        (this.allocations[index].businessUnitValue === this.allocations[i].businessUnitValue &&
          (this.allocations[index].businessUnitValue === '20048' ||
            this.allocations[index].businessUnitValue === '50125') &&
          this.allocations[index].operatingUnit.OPERATING_UNIT ===
            this.allocations[i].operatingUnit.OPERATING_UNIT)
      ) {
        if (firstMatchIndex !== -1) {
          this.allocations[i].fundingProjectID = this.allocations[firstMatchIndex].fundingProjectID;
          this.allocations[i].state = this.allocations[firstMatchIndex].state;
        }
        if (firstMatchIndex === -1) {
          firstMatchIndex = i;
        }
      }
    }
  }

  isFormOwner() {
    return (
      this.userEmail &&
      this.formOwner &&
      this.formOwner.mail &&
      this.userEmail.toLowerCase() === this.formOwner.mail.toLowerCase()
    );
  }

  isPACUser() {
    return this.userRoles.includes('MMAPS_ETS_PAC_Users');
  }

  showDelete() {
    if (this.isPACUser()) return true;
    if (!this.formOwner) return true;
    return this.isFormOwner();
  }

  openDeleteConfirmationDialog(): void {
    const dialogRef = this.dialog.open(ConfirmDeleteFormDialogComponent, {
      width: '400px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'delete') {
        this.deleteForm();
      }
    });
  }

  deleteForm(): void {
    this.saveItSparData(true);
  }
}
